const BUILDING_INSPECTION = {
  // help text shown in the info "i" next to inspection fields
  tooltips: {
    info: {
      buildingCategory:
        'Velg hovedkategori for bygget, for eksempel kontor, skole eller lager. Feltet brukes til å velge riktige standardverdier og profiler i beregningen.',
      yearOfConstruction:
        'Oppgi byggeår for bygget, eller året for siste vesentlige ombygging dersom dette er mer representativt. Brukes blant annet til å vurdere sannsynlig teknisk standard.',
      numberOfFloors:
        'Oppgi totalt antall etasjer over bakken for bygget. Feltet brukes som grunnlag for geometri, volum og videre inndeling i soner.',
    },
    thermalZones: {
      zoneCategory:
        'En termisk sone er et område av bygget som behandles samlet i beregningen, typisk med lik bruk og inneklima. Gi sonen et tydelig navn og velg sonekategori. Kategorien bestemmer standardprofiler for brukstid, interne laster og tekniske forutsetninger.',
      buildingSubcategory:
        'Velg underkategori hvis du ønsker en mer presis klassifisering av sonen. La feltet stå tomt hvis vanlig sonekategori er tilstrekkelig.',
      zoneClimate:
        'Angir om sonen er oppvarmet, delvis oppvarmet eller uoppvarmet. Klimastatusen avgjør hvordan sonen inngår i oppvarmings og kjølebehovet, og er en grunnleggende forutsetning for energiberegningen.',
      bra: 'BRA er bruksarealet til sonen, altså gulvarealet innenfor ytterveggene som regnes som oppvarmet areal. Oppgi BRA i m². Arealet er et av de viktigste inputene og påvirker nesten alle beregninger direkte.',
      floors:
        'Oppgi hvor mange etasjer sonen strekker seg over dersom den ikke er begrenset til ett plan. Hvis sonen kun ligger i ett plan kan feltet ofte stå tomt.',
      floorHeight:
        'Oppgi gjennomsnittlig etasjehøyde i meter for sonen. Brukes sammen med areal til å beregne volum og luftmengder.',
      indoorTemp:
        'Temperaturen sonen har når simuleringen starter. Dette er ikke et settpunkt: settpunktene for oppvarming og kjøling angis i Oppvarmingsplan og Kjøleplan.',
      tekStandard:
        'TEK er de norske byggtekniske forskriftene, for eksempel TEK10 og TEK17, som setter krav til blant annet U-verdier og tetthet. Velg relevant TEK-standard dersom du vil styre standardverdiene mer presist enn byggeår alene gir.',
      airLeakageN50:
        'Lekkasjetall (n50) beskriver hvor lufttett bygget er, målt som antall luftvekslinger per time ved 50 Pa trykkforskjell. Oppgi verdien dersom den er kjent fra trykktesting eller dokumentasjon. Hvis feltet er tomt brukes representative standardverdier.',
      thermalBridgeCoeff:
        'En kuldebro er et sted i konstruksjonen med økt varmetap, typisk der dekker og vegger møter ytterkonstruksjonen. Velg bærekonstruksjon eller kuldebrokategori dersom du vil modellere kuldebroene mer presist. Brukes normalt bare når du har god bygningsfysisk informasjon.',
      thermalBridgePsiValue:
        'Normalisert kuldebroverdi (ψ) uttrykker samlet ekstra varmetap fra kuldebroer per m² gulvareal. Oppgi verdien hvis den er kjent fra beregning. Kan normalt stå tomt i en standard kartlegging.',
      heatingEmissionSystem:
        'Varmeavgivelsessystemet er måten varmen leveres til rommet på, for eksempel radiator, konvektor eller gulvvarme. Valget påvirker nødvendig turtemperatur og regulering. Nyttig for detaljering, men som regel ikke nødvendig i første registrering.',
      coolingEmissionSystem:
        'Kjøleavgivelsessystemet er måten kjølingen leveres til rommet på, for eksempel kjølebaffel, viftekonvektor eller kjøletak. Valget påvirker temperaturnivå og regulering. Nyttig for detaljering, men som regel ikke nødvendig i første registrering.',
      zoneConnections:
        'En sonekobling beskriver en flate der to soner, eller en sone og en klimabetingelse, utveksler varme, for eksempel en innervegg mot en kaldere sone. Bruk dette når slik varmeutveksling er viktig for modellen. Normalt kun aktuelt ved mer detaljert oppsett.',
      connectionArea:
        'Oppgi arealet i m² for flaten som kobler sonene. Sammen med U-verdien bestemmer den hvor mye varme som utveksles. Fylles bare ut når du faktisk modellerer en sonekobling.',
      connectionUValue:
        'U-verdien beskriver hvor godt flaten mellom sonene isolerer (W/m²K). Oppgi den hvis du har den tilgjengelig. Hvis ikke kan koblingen som regel forenkles eller utelates.',
      heatingSchedule:
        'En oppvarmingsplan beskriver hvordan settpunkt og drift varierer gjennom døgnet og uken, for eksempel nattsenking. Bruk den når sonen har avvikende drift. Gir en mer realistisk simulering enn faste standardprofiler.',
      hasFloorToGround:
        'Aktiver dette hvis sonen har gulv mot grunn. Deaktivering skjuler elementet og fjerner det lagrede arealet fra energiberegningen.',
      hasRoof:
        'Aktiver dette hvis sonen har yttertak mot det fri. Deaktivering skjuler elementet og fjerner det lagrede arealet fra energiberegningen.',
      isBasement:
        'Aktiver dette når sonen er en kjeller under terreng. Varmetapet mot grunnen beregnes da fra elementet Kjellerkonstruksjon, og yttertak, gulv mot grunn, yttervegger, vinduer og dører på denne sonen holdes utenfor energiberegningen.',
      basement: {
        area: 'Oppgi kjellerens gulvareal mot grunn i m². Arealet er nødvendig for å beregne varmetapet mot grunnen og er normalt likt BRA for kjellersonen.',
        wallPerimeter:
          'Oppgi lengden i meter av kjellervegg som grenser mot grunnen. Sammen med arealet gir den gulvets karakteristiske dimensjon. Står feltet tomt, antas en kvadratisk grunnflate.',
        fillHeight:
          'Oppgi gjennomsnittlig dybde fra terreng ned til kjellergulvet i meter. Avgjør hvor mye av veggen som avgir varme til grunnen. 0 betyr plate på mark.',
        wallThickness:
          'Oppgi kjellerveggens totale tykkelse ved terrengnivå i meter, inkludert isolasjon. 0,3 m brukes når feltet står tomt.',
        wallConstructionType:
          'Velg konstruksjonen på kjellerveggen under terreng, eller en TEK periode for å bruke kravet derfra. Valget foreslår U-verdi.',
        wallUValue:
          'U-verdien til kjellerveggens konstruksjon under terreng (W/m²K). Oppgi den hvis du kjenner den fra dokumentasjon, ellers brukes den foreslåtte verdien.',
        floorConstructionType:
          'Velg konstruksjonen på kjellergulvet mot grunnen, eller en TEK periode for å bruke kravet derfra. Valget foreslår U-verdi.',
        floorUValue:
          'U-verdien til kjellergulvets konstruksjon mot grunnen (W/m²K). Oppgi den hvis du kjenner den fra dokumentasjon, ellers brukes den foreslåtte verdien.',
      },
      floor: {
        type: 'Typen gulv mot grunn beskriver hvordan gulvet mot grunn eller mot uoppvarmet rom er bygd opp, for eksempel plate på mark eller gulv over kjeller. Velg den som best beskriver konstruksjonen. Valget brukes til å foreslå relevante standardverdier, blant annet U-verdi.',
        area: 'Oppgi areal for gulv mot grunn i m² for den delen av sonen som skal registreres. Arealet er nødvendig for å beregne varmetap gjennom gulvet.',
        uValue:
          'U-verdien angir hvor mye varme som slipper gjennom konstruksjonen per m² og grad temperaturforskjell (W/m²K). Lavere verdi betyr bedre isolering. Oppgi den hvis du kjenner den fra dokumentasjon eller beregning, ellers brukes nominelle verdier ut fra valgt type og år.',
      },
      structuralNodes: {
        boundary:
          'En strukturell node er et sted der bygningsdeler møtes, for eksempel mellom dekke og yttervegg, og er typisk en kuldebro med ekstra varmetap. Bruk strukturelle noder når du vil registrere slike detaljer. Normalt kun aktuelt ved høyere detaljnivå.',
        length:
          'Oppgi lengde for den aktuelle noden eller kuldebroen i meter. Fylles kun ut dersom strukturelle noder brukes.',
        height:
          'Oppgi høyde for den aktuelle noden i meter dersom relevant. Brukes sammen med øvrige mål for detaljert geometribeskrivelse.',
        width:
          'Oppgi bredde for den aktuelle noden i meter dersom relevant. Feltet brukes kun ved detaljert registrering av strukturelle noder.',
      },
      roof: {
        angle:
          'Takvinkelen er takflatens helning i grader, der 0 betyr flatt tak. Den registreres for befaringen, men energiberegningen bruker den ikke ennå: varmetapet gjennom taket regnes fra areal og U-verdi, og takvinduer får ikke solinnstråling i beregningen.',
        type: 'Takkonstruksjonen beskriver hvordan yttertaket er bygd opp, for eksempel kompakt tak, luftet skråtak eller takstoler. Velg den som best beskriver yttertaket. Valget gir grunnlag for standard U-verdi og øvrige forutsetninger.',
        area: 'Oppgi takareal i m² som inngår i sonen. Arealet er nødvendig for å beregne transmisjon gjennom yttertaket.',
        uValue:
          'U-verdien angir hvor mye varme som slipper gjennom takkonstruksjonen per m² og grad temperaturforskjell (W/m²K). Lavere verdi betyr bedre isolering. Oppgi den hvis den er kjent, ellers brukes nominell verdi ut fra valgt konstruksjon og alder.',
        glassType:
          'Aktiver dette dersom yttertaket har vinduer eller taklys, og velg glasstype. Glasstypen, for eksempel to eller tre lags, bestemmer både varmetap og hvor mye solenergi som slipper inn gjennom takflaten.',
        windowArea:
          'Oppgi samlet vindusareal eller taklysareal i m². Feltet er bare relevant hvis yttertaket faktisk har vinduer eller taklys.',
        windowUValue:
          'U-verdien for takvinduene angir varmetapet gjennom selve glasset og rammen (W/m²K). Lavere verdi betyr bedre isolering. Oppgi den hvis den er kjent, ellers er standardverdier ofte tilstrekkelige.',
        gValue:
          'G-verdien (solfaktor) beskriver hvor stor andel av solenergien som slipper gjennom glasset, fra 0 til 1. Høy g-verdi gir mer gratis solvarme om vinteren, men også større kjølebehov om sommeren.',
        externalBlindsGt:
          'Utvendige persienner sitter på utsiden av glasset og reduserer solinnstrålingen effektivt. Solfaktoren (gt) beskriver hvor mye solenergi som slipper gjennom når avskjermingen er aktiv. Registrer dette når slik solavskjerming har tydelig effekt.',
        externalScreenGt:
          'En utvendig duk eller screen er en utvendig tekstilavskjerming som demper solinnstråling. Solfaktoren (gt) angir hvor mye solenergi som slipper gjennom med duken nede. Fylles bare ut dersom løsningen finnes i bygget.',
        internalShadingGt:
          'Innvendig solskjerming, for eksempel persienner eller gardiner på innsiden, demper sol men mindre effektivt enn utvendig avskjerming. Solfaktoren (gt) beskriver gjenværende solinnslipp. Brukes for å forbedre beregningen av soltilskudd.',
      },
      groundConditions: {
        type: 'Grunnforhold beskriver massene under bygget, for eksempel leire, sand eller fjell, som påvirker varmetapet mot grunnen. Bruk dette når du har spesifikk informasjon om grunnen. Dette er typisk et detaljfelt.',
        thermalConductivity:
          'Varmekonduktivitet (λ) angir hvor godt grunnen leder varme, i W/mK. Høyere verdi gir større varmetap mot grunnen. Oppgi en dokumentert verdi hvis du har den, ellers kan feltet stå tomt.',
        heatCapacity:
          'Varmekapasiteten beskriver hvor mye varme grunnen kan lagre, og demper svingninger i varmetapet over tid. Oppgi den dersom den er kjent. Kan normalt stå tomt i en ordinær energikartlegging.',
        penetrationDepth:
          'Periodisk nedtrengningsdybde er dybden i grunnen som påvirkes av årstidsvariasjoner i temperatur. Den brukes i mer detaljerte grunnmodeller. Feltet er vanligvis ikke nødvendig i standard registrering.',
      },
      internalLoads: {
        lighting:
          'Belysning er en intern varmelast: energien lyskildene bruker ender stort sett opp som varme i sonen. Registrer belysningsnivå og eventuelle driftsprofiler. Dette påvirker både elforbruk og kjølebehov.',
        equipment:
          'Teknisk utstyr som PC-er, skjermer og annet fast utstyr avgir varme til rommet i tillegg til å bruke strøm, og er derfor en intern varmelast. Registrer typisk effekt og driftsprofil for sonen.',
        occupancy:
          'Personer avgir varme og fukt og påvirker samtidig ventilasjonsbehovet. Registrer personbelastning gjennom antall og profiler eller et standardoppsett som beskriver normal bruk av sonen.',
        dishwasher:
          'Kryss av for oppvaskmaskin hvis den er en relevant last i sonen. Andelen på varmtvann angir hvor mye av forbruket som dekkes av oppvarmet tappevann fremfor maskinens egen oppvarming. Brukes normalt bare når hvitevarer er betydelige.',
        washingMachine:
          'Kryss av for vaskemaskin hvis den er en relevant last i sonen. Andelen på varmtvann angir hvor stor del av vannet maskinen henter fra varmtvannssystemet i stedet for å varme det selv.',
        tumbleDryer:
          'Kryss av for tørketrommel hvis den er en relevant last i sonen. En eventuell varmtvannsandel beskriver hvor mye av energibehovet som dekkes via varmt tappevann fremfor direkte el.',
      },
      thermalMass: {
        heatCapacityCategory:
          'Termisk masse er byggets evne til å lagre varme, noe som demper temperatursvingninger og forskyver varme og kjølebehov i tid. Velg varmekapasitetskategori, for eksempel lett eller tung konstruksjon, hvis du vil justere dette utover standardverdier.',
        normalizedHeatCapacity:
          'Normalisert varmekapasitet uttrykker hvor mye varme sonen kan lagre per m² gulvareal (Wh/m²K). Oppgi en mer presis verdi hvis du har den, ellers kan feltet stå tomt og kategorien brukes.',
        cladding:
          'Innvendig kledning, for eksempel gips, tre eller eksponert betong, påvirker hvor mye av den termiske massen som faktisk er aktiv mot rommet. Velg type dersom du ønsker en mer detaljert beskrivelse.',
        heatCapacity:
          'Oppgi varmekapasitet for innervegger dersom den er kjent. Dette beskriver hvor mye varme de indre konstruksjonene kan lagre, og brukes kun ved mer detaljert modellering av termisk masse.',
        furnitureGrade:
          'Møbler og inventar bidrar også til termisk masse. Velg møbelgrad som beskriver hvor møblert sonen er dersom dette har betydning. Feltet er normalt et detaljfelt.',
        massFactor:
          'Massefaktoren justerer hvor mye møbler og inventar bidrar til sonens termiske masse. Oppgi en verdi dersom du ønsker å overstyre standardverdien.',
      },
      exteriorWall: {
        direction:
          'Himmelretningen bestemmer hvor mye sol fasaden mottar og hvordan vind og uteklima påvirker varmetapet. Velg retning, for eksempel nord, sør, øst eller vest, for veggen som registreres.',
        type: 'Veggtypen beskriver hvordan ytterveggen er bygd opp, for eksempel bindingsverk, mur eller betong med isolasjon. Velg den som best beskriver veggen. Valget brukes til å foreslå relevante standardverdier.',
        area: 'Oppgi bruttoarealet til ytterveggen i m², inkludert vinduer, dører og porter. Beregningen trekker selv fra åpningene som er registrert på veggen, så nettoareal gir for lite varmetap gjennom veggen.',
        uValue:
          'U-verdien angir hvor mye varme som slipper gjennom veggen per m² og grad temperaturforskjell (W/m²K). Lavere verdi betyr bedre isolering. Oppgi den hvis den er kjent, ellers brukes nominelle verdier ut fra veggtype og alder.',
        windowShadingFactor:
          'Andelen direkte sollys vinduet mister på grunn av skygge fra utspring, nabobygg eller terreng, fra 0 til 1. 0 betyr ingen skygge og 1 betyr helt skyggelagt. Bare direkte sol reduseres, ikke diffus stråling. Persienner og screens nedenfor registreres, men brukes ikke i beregningen.',
      },
      heatingCooling: {
        name: 'Gi utstyret et tydelig navn som gjør det enkelt å skille komponenter fra hverandre. Navnet brukes først og fremst til identifikasjon i prosjektet.',
        type: 'Typen beskriver hva slags varme eller kjøleenhet dette er, for eksempel radiator, gulvvarme, varmepumpe eller kjølebaffel. Valget styrer hvilke felter som er relevante og hvordan systemet modelleres.',
        energySource:
          'Energikilden er hva enheten bruker for å produsere varme eller kjøling, for eksempel elektrisitet, fjernvarme eller en varmepumpe. Velg kilde dersom komponenten er direkte koblet til en bestemt kilde, ellers kan energiforsyningen beskrives sentralt.',
        co2eEmissionFactor:
          'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp som følger med energien enheten bruker, oppgitt per kWh. Oppgi en spesifikk verdi hvis du vil beregne utslipp presist. Den påvirker ikke selve energibehovet.',
        quantity:
          'Oppgi antall like enheter dersom flere identiske enheter er installert. Kan stå tomt hvis effekten oppgis samlet.',
        power:
          'Nominell effekt er enhetens maksimale varme eller kjøleytelse i kW. Den brukes til å vurdere om systemet har kapasitet til å dekke behovet, og hvordan flere systemer prioriteres. Oppgi samlet effekt dersom flere like enheter slås sammen.',
        systemEfficiency:
          'Systemvirkningsgraden beskriver hvor stor del av tilført energi som faktisk blir nyttig varme eller kjøling, inkludert tap i distribusjon og regulering. Oppgi et bedre tall enn standard hvis du har det. Ofte ikke nødvendig i første registrering.',
        priority:
          'Prioriteten styrer rekkefølgen systemene tas i bruk når flere dekker samme behov. Lavere prioritet betyr at systemet brukes først, og resten dekker spisslast. Angi dette dersom sonen har flere varme eller kjølekilder.',
        cop: 'COP (Coefficient of Performance) er varmepumpens virkningsgrad for oppvarming: forholdet mellom levert varme og tilført strøm. En COP på 3 betyr tre ganger så mye varme som strøm. Oppgi en spesifikk verdi dersom du har den.',
        eer: 'EER (Energy Efficiency Ratio) er virkningsgraden for kjøling: forholdet mellom levert kjøling og tilført strøm. Høyere verdi betyr mer effektiv kjøling. Oppgi en spesifikk verdi dersom du har den.',
        nominalLoad:
          'Nominell last (0-1) beskriver hvilken andel av full kapasitet enheten er dimensjonert for å kjøre på normalt. Dette er et detaljfelt og kan vanligvis stå på standardverdi.',
        minimumLoad:
          'Minimumslast (0-1) er den laveste andelen av full kapasitet enheten kan kjøre stabilt på før den må slå seg av og på. Oppgi en verdi dersom du vil overstyre standarden.',
        degradeCoeff:
          'Degraderingskoeffisienten (0-1) beskriver hvor mye virkningsgraden faller når enheten kjører på dellast i stedet for full effekt. Inverterstyrte enheter har som regel lavere tap. Settes ofte automatisk.',
        maxTemperatureSupplied:
          'Maksimal turtemperatur er den høyeste temperaturen enheten kan levere til varmeavgivelsessystemet. Den avgjør om enheten klarer å dekke temperaturbehovet, for eksempel til radiatorer som krever høy turtemperatur.',
      },
      domesticHotWater: {
        name: 'Gi tappevannskomponenten et tydelig navn hvis du registrerer flere enheter eller delsystemer.',
        heaterType:
          'Varmetypen beskriver hvordan tappevannet varmes opp, for eksempel direkte elektrisk bereder, varmepumpe eller sentral forsyning som fjernvarme. Valget påvirker både energibehov og utslipp for varmt tappevann.',
        tapFrequency:
          'Tappefrekvensen beskriver hvor ofte og hvor mye varmt vann som tappes, og gjenspeiler faktisk bruksmønster i sonen. Den er en viktig driver for beregnet energibehov til tappevann.',
        tapCyclesPerDay:
          'Antall tappesykluser per døgn er hvor mange ganger det tappes varmt vann i løpet av et døgn. Oppgi en verdi dersom du vil overstyre standardprofilen med et mer presist tall.',
        thermalZone:
          'Knytt tappevannssystemet til den termiske sonen det betjener. Dette plasserer energibruken og eventuell varmeavgivelse riktig i modellen.',
      },
      productionEquipment: {
        name: 'Gi produksjonsutstyret et tydelig navn. Brukes for å identifisere lasten i prosjektet og i rapporter.',
        energySource:
          'Energikilden er hva produksjonsutstyret bruker, for eksempel elektrisitet eller gass. Den brukes til å fordele energibruk på riktig bærer og til eventuell utslippsberegning.',
        power:
          'Nominell effekt er utstyrets typiske effektopptak i kW. Sammen med driftsplanen gir den grunnlag for å beregne energibruk og varmeavgivelse til sonen.',
        eligibleForHarvesting:
          'Energigjenvinning betyr å utnytte overskuddsvarme fra utstyret til andre formål, for eksempel oppvarming. Kryss av dersom utstyret avgir slik overskuddsenergi, så vurderes gjenvinningspotensialet.',
        operationalSchedule:
          'Driftsplanen beskriver når utstyret faktisk er i bruk gjennom døgnet og uken. Legg den inn hvis utstyret ikke følger normal driftstid, for en mer realistisk beregning av energibruk og interne laster.',
      },
      hvac: {
        name: 'Gi ventilasjonsaggregatet et tydelig navn. Navnet brukes til identifikasjon dersom bygget har flere aggregater.',
        linkedZones:
          'Koblede soner er de termiske sonene ventilasjonsaggregatet betjener med luft. Valget er nødvendig for å fordele luftmengder, vifteenergi og varmegjenvinning riktig mellom sonene.',
        flowSfpSettings:
          'Her legger du inn aggregatets luftmengder og SFP-forutsetninger. SFP (spesifikk vifteeffekt) uttrykker hvor mye elektrisk effekt viftene bruker per luftmengde, og er kjerneinformasjon for ventilasjonsberegningen.',
        motorType:
          'Motortypen, for eksempel AC eller EC, påvirker viftens virkningsgrad og hvordan effekten endrer seg på dellast. Velg type dersom den er kjent for mer presis beregning.',
        sfp100:
          'SFP (spesifikk vifteeffekt) er forholdet mellom viftenes effektopptak og luftmengden, oppgitt i kW per m³/s. Lavere SFP betyr mer energieffektiv vifte. Oppgi verdien ved 100 % drift, dette er hovedparameteren i ventilasjonsberegningen.',
        sfp80:
          'SFP ved 80 % drift beskriver spesifikk vifteeffekt når aggregatet kjører på redusert luftmengde. Oppgi den hvis du har delastdata, ellers kan feltet stå tomt.',
        sfp60:
          'SFP ved 60 % drift beskriver spesifikk vifteeffekt på lavere luftmengde. Brukes kun ved mer detaljert modellering av delast.',
        sfp40:
          'SFP ved 40 % drift. Oppgi den hvis delastdata for så lav luftmengde er tilgjengelig.',
        sfp20:
          'SFP ved 20 % drift. Oppgi den hvis delastdata for så lav luftmengde er tilgjengelig.',
        fanPowerIn:
          'Vifteeffekt tilluft er det elektriske effektopptaket til tilluftsviften i kW. Oppgi den hvis du har den separat. Kan normalt stå tomt når SFP er registrert, siden effekten da beregnes derfra.',
        fanPowerOut:
          'Vifteeffekt avtrekk er det elektriske effektopptaket til avtrekksviften i kW. Oppgi den hvis du har den separat. Brukes kun ved mer detaljert registrering.',
        coverageArea:
          'Dekningsareal er gulvarealet aggregatet betjener i m². Oppgi det dersom aggregatet bare dekker en del av bygget eller sonen. Kan ofte utledes fra tilknyttede soner.',
        coverageVolume:
          'Dekningsvolum er luftvolumet aggregatet betjener i m³. Oppgi det dersom det er kjent. Brukes som detaljfelt ved ventilasjonsdimensjonering.',
        airVolumeOperating:
          'Tilluftmengde i drift er luftmengden aggregatet leverer under normal drift, i m³/h. Dette er en sentral input for ventilasjonsbehov, vifteenergi og varme og kjølebatterier.',
        airVolumeCapacity:
          'Tilluftkapasitet er maksimal luftmengde aggregatet kan levere, i m³/h. Oppgi den dersom den er kjent. Nyttig for kapasitetsvurderinger, men ikke alltid nødvendig.',
        airVolumeNonOperating:
          'Tilluftmengde utenfor drift er luftmengden aggregatet leverer når bygget ikke er i bruk, for eksempel ved redusert nattdrift. Oppgi den hvis aggregatet går med redusert luftmengde i deler av tiden.',
        airVolumeExtractionOperating:
          'Avtrekksmengde i drift er luften aggregatet trekker ut av sonene under normal drift, i m³/h. Sammen med tilluftmengden beskriver den aggregatets faktiske luftbalanse og påvirker vifteenergi og varmegjenvinning.',
        airVolumeExtractionCapacity:
          'Avtrekkskapasitet er maksimal luftmengde aggregatet kan trekke ut, i m³/h. Oppgi den dersom den er kjent. Nyttig for kapasitetsvurderinger, men ikke alltid nødvendig.',
        airVolumeExtractionNonOperating:
          'Avtrekksmengde utenfor drift er luften aggregatet trekker ut når bygget ikke er i bruk, for eksempel ved nattsenking eller redusert drift. Oppgi den dersom aggregatet går med redusert luftmengde i deler av tiden.',
        supplyTemperature:
          'Tillufttemperaturen er temperaturen på lufta aggregatet blåser inn i sonen, i °C. Settpunktene i driftsplanen har forrang: denne verdien brukes bare for timer der driftsplanen ikke har et settpunkt. Endre settpunktet for tilluft i driftsplanen.',
        heatRecoveryType:
          'Varmegjenvinning gjenbruker varmen i avtrekksluften til å forvarme tilluften, slik at oppvarmingsbehovet reduseres. Velg typen som er installert, for eksempel roterende gjenvinner, plateveksler eller batterigjenvinner. Valget er viktig for beregningen av gjenvunnet energi.',
        efficiencyHR:
          'Virkningsgraden angir hvor stor andel av varmen i avtrekksluften gjenvinneren faktisk overfører til tilluften, i prosent. Høyere verdi betyr mindre oppvarmingsbehov. Oppgi en dokumentert verdi hvis du har den, ellers brukes en standardverdi ut fra valgt type.',
        frostProtection:
          'Frostbeskyttelse hindrer at gjenvinneren fryser til ved lave utetemperaturer, men kan i perioder redusere hvor mye varme som gjenvinnes. Kryss av dersom aggregatet har frostbeskyttelse som påvirker drift eller varmegjenvinning. Nyttig ved mer presis modellering.',
        frostProtectionTemperature:
          'Dette er utetemperaturen der frostbeskyttelsen aktiveres. Under denne temperaturen reduseres eller styres gjenvinningen for å unngå ising. Oppgi verdien dersom den er kjent, ellers brukes en standardverdi.',
        measuredSupplyTemp:
          'Målt tillufttemperatur er den faktiske temperaturen på lufta aggregatet blåser inn, registrert ved en befaring eller logging. Oppgi den dersom du har feltmålinger. Brukes til kvalitetssikring og mer presis kalibrering av modellen.',
        measuredExhaustTemp:
          'Målt avtrekkstemperatur er den faktiske temperaturen på lufta som trekkes ut av sonene, registrert ved feltmåling. Oppgi den dersom du har slike målinger. Sammen med målt tillufttemperatur brukes den til kvalitetssikring.',
        dx: {
          name: 'Et DX-system (direkte ekspansjon) er et kjøle eller varmepumpebatteri der kuldemediet fordamper direkte i luftstrømmen, uten en vannkrets imellom. Gi enheten et tydelig navn for identifikasjon dersom aggregatet har en slik integrert DX-enhet.',
          type: 'Typen angir hva DX-enheten kan gjøre: kun kjøling, kun oppvarming, eller begge (varmepumpefunksjon). Valget styrer hvilke effekt og virkningsgradsfelter som er relevante.',
          heatingEffect:
            'Varmeeffekten er den maksimale varmen DX-enheten kan levere til lufta, i kW. Oppgi den dersom systemet leverer varme. Kan stå tomt hvis enheten bare brukes til kjøling.',
          coolingEffect:
            'Kjøleeffekten er den maksimale kjølingen DX-enheten kan levere til lufta, i kW. Dette er normalt den viktigste kapasitetsverdien for kjøledrift.',
          seasonalCop:
            'Sesong-COP er DX-enhetens gjennomsnittlige virkningsgrad for oppvarming over en sesong: forholdet mellom levert varme og tilført strøm. Oppgi den dersom enheten også brukes til oppvarming. Bruk standardverdi hvis presis dokumentasjon mangler.',
          seasonalEer:
            'Sesong-EER er DX-enhetens gjennomsnittlige virkningsgrad for kjøling over en sesong: forholdet mellom levert kjøling og tilført strøm. Oppgi den hvis den er kjent. Brukes til å beregne elforbruk for kjøling.',
          systemEfficiency:
            'Beregningen bruker systemvirkningsgraden som DX-enhetens egen virkningsgrad, i prosent: 300 % betyr tre ganger så mye varme eller kjøling som strøm. Feltene for sesong-COP/EER brukes ikke ennå, så oppgi COP eller EER her som prosent. Står feltet tomt, brukes 100 %.',
          energySource:
            'Energikilden er hva DX-enheten bruker for å produsere varme eller kjøling, normalt elektrisitet. Den brukes til energifordeling og eventuell utslippsberegning.',
        },
        heatingBattery: {
          name: 'Et varmebatteri i ventilasjon er en varmeveksler i aggregatet som varmer opp tilluften, typisk forsynt med varmtvann fra en kjele eller varmepumpe, eller elektrisk. Gi batteriet et tydelig navn dersom flere batterier finnes i samme aggregat eller bygg.',
          type: 'Batteritypen angir hvordan varmen tilføres, for eksempel vannbåren (varmtvann gjennom batteriet) eller elektrisk. Valget påvirker energikilde og virkningsgrad.',
          power:
            'Varmeeffekten er den maksimale varmen batteriet kan tilføre tilluften, i kW. Brukes til kapasitetskontroll og energiberegning.',
          systemEfficiency:
            'Systemvirkningsgraden fanger opp tap i distribusjon og regulering fram til batteriet. Oppgi en verdi dersom du har et bedre tall enn standard, ellers kan feltet stå tomt.',
          energySource:
            'Energikilden er hva som forsyner varmebatteriet med varme, for eksempel fjernvarme, kjele, varmepumpe eller elektrisitet. Den brukes til energifordeling og eventuell utslippsberegning.',
        },
        coolingBattery: {
          name: 'Et kjølebatteri i ventilasjon er en varmeveksler i aggregatet som kjøler ned tilluften, typisk forsynt med kaldtvann fra en kjølemaskin eller direkte ekspansjon (DX). Gi batteriet et tydelig navn dersom flere batterier finnes.',
          type: 'Typen angir hvordan kjølingen tilføres, for eksempel vannbåren (kaldtvann gjennom batteriet) eller DX (direkte ekspansjon). Valget påvirker energikilde og virkningsgrad.',
          power:
            'Kjøleeffekten er den maksimale kjølingen batteriet kan tilføre tilluften, i kW. Brukes til kapasitetskontroll og energiberegning.',
          systemEfficiency:
            'Systemvirkningsgraden fanger opp tilleggstap i distribusjon og regulering utover nominell ytelse. Oppgi en verdi dersom du ønsker å ta med slike tap, ellers kan feltet stå tomt.',
          eer: 'EER (Energy Efficiency Ratio) er kjølebatteriets virkningsgrad: forholdet mellom levert kjøling og tilført strøm. Oppgi den hvis den er kjent. Brukes til å beregne elektrisk energibruk ved kjøling.',
          energySource:
            'Energikilden er hva som forsyner kjølebatteriet med kjøling, for eksempel kjølemaskin, fjernkjøling eller DX. Den brukes til energifordeling og eventuell utslippsberegning.',
        },
        naturalVentilation:
          'Naturlig ventilasjon er luftutskifting drevet av vind og temperaturforskjeller gjennom vinduer, ventiler eller sjakter, uten vifter. Aktiver dette dersom sonen eller aggregatet har naturlig ventilasjon som skal inngå i modellen.',
        operationalSchedule:
          'En driftsplan beskriver når ventilasjonen er i drift gjennom døgnet og uken. Legg inn en plan for naturlig ventilasjon eller aggregatdrift dersom driften avviker fra standard driftstid.',
        operationalScheduleExtra:
          'Bruk en ekstra driftsplan når samme aggregat eller ventilasjonsfunksjon har flere driftsperioder med ulik drift, for eksempel sesongvis. Hver plan dekker en egen periode.',
      },
      centralEnergy: {
        name: 'En sentral energimodul er en felles energisentral som forsyner flere soner eller funksjoner, for eksempel en varmesentral eller kjølemaskinsentral. Gi den et tydelig navn. Navnet brukes kun til identifikasjon.',
        mode: 'Modus angir om sentralen leverer oppvarming, kjøling, varmtvann eller kombinasjoner av disse. Dette er en grunnleggende innstilling som styrer hvordan sentralen brukes i modellen.',
        thermalZone:
          'En sentral kan knyttes til en termisk sone slik at omgivelsestemperaturen rundt sentralen følger sonen, noe som påvirker virkningsgrad og tap. Koble til relevant sone dersom plassering eller omgivelsestemperatur er viktig for beregningen, ellers kan den stå som frittstående.',
        ambientTemperature:
          'Omgivelsestemperaturen er temperaturen i rommet der sentralen står, for eksempel et teknisk rom. Den brukes bare når sentralen ikke er koblet til en termisk sone, og påvirker varmetap fra sentralen og lagringstanker. Er en sone valgt, hentes temperaturen derfra i stedet.',
        sourceName:
          'Gi energikilden et tydelig navn slik at den er enkel å kjenne igjen dersom sentralen har flere energikilder. Navnet brukes kun til identifikasjon.',
        usage:
          'Disse valgene styrer hva energikilden faktisk dekker: oppvarming, kjøling og/eller tappevann (VVT). Velg de behovene kilden bidrar til. Omformerstyrt betyr at enheten kan modulere effekten, noe som gir bedre virkningsgrad på dellast.',
        heatPump: {
          type: 'Varmepumpetypen beskriver hvor varmepumpen henter og avgir energi: luft-vann tar energi fra uteluft og leverer til vannbåren varme, væske-vann henter fra grunn, fjell eller vann via en kollektor, og luft-luft varmer inneluften direkte. Valget påvirker virkningsgrad og hvilke tilleggsfelter som vises.',
          co2eEmissionFactor:
            'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp som følger med energien varmepumpen bruker, oppgitt per kWh. Oppgi en spesifikk verdi bare hvis du vil beregne utslipp presist. Den påvirker ikke selve energibehovet.',
          heatingCapacity:
            'Varmekapasiteten er varmepumpens nominelle varmeeffekt i kW, altså hvor mye varme den kan levere under normale forhold. Dette er den viktigste kapasitetsverdien og brukes til å vurdere om pumpen dekker varmebehovet.',
          nominalLoad:
            'Nominell last (0-1) er den andelen av full kapasitet varmepumpen er dimensjonert for å kjøre på normalt. Oppgi den dersom dokumentasjonen oppgir den separat. Brukes ved detaljert delastmodellering.',
          minimumLoad:
            'Minimum last (0-1) er den laveste andelen av full kapasitet varmepumpen kan kjøre stabilt på før den må slå seg av og på. Oppgi den hvis pumpen kan modulere og dette er kjent.',
          degradeCoeff:
            'Degraderingskoeffisienten (0-1) beskriver hvor mye virkningsgraden faller når varmepumpen kjører på dellast i stedet for full effekt. Oppgi den dersom produsentdata eller beregninger foreligger. Kan normalt stå tomt, da settes den til 0,8 etter NS 3031, eller 0,6 for inverterstyrte enheter.',
          maxTemperatureSupplied:
            'Høyeste leverte temperatur er den varmeste turtemperaturen varmepumpen kan levere til varmesystemet, i °C. Varmepumper får lavere virkningsgrad ved høy turtemperatur. Brukes til å vurdere om pumpen dekker temperaturbehovet, for eksempel til radiatorer som krever høy temperatur.',
          cop: 'COP (Coefficient of Performance) er varmepumpens virkningsgrad for oppvarming: forholdet mellom levert varme og tilført strøm. En COP på 3 betyr tre ganger så mye varme som strøm. Oppgi en spesifikk verdi dersom du har den, ellers brukes standardverdier.',
          eer: 'EER (Energy Efficiency Ratio) er varmepumpens virkningsgrad for kjøling: forholdet mellom levert kjøling og tilført strøm. EER 3 betyr tre ganger så mye kjøling som strøm. Brukes når varmepumpen er krysset av for kjøling. Står feltet tomt, brukes COP.',
          liquidSource:
            'Væskekilden er mediet væske-vann-varmepumpen henter energi fra via en kollektor, for eksempel grunn, fjell, ferskvann eller sjøvann. Kilden påvirker tilgjengelig kildetemperatur og dermed virkningsgraden.',
          sourceTemperature:
            'Kildetemperaturen er temperaturen på væsken som kommer fra kilden inn til varmepumpen, i °C. Høyere kildetemperatur gir bedre virkningsgrad. Oppgi den dersom den er kjent fra måling eller grunnundersøkelse.',
          sourceYearlyAverageTemperature:
            'Årsmiddeltemperaturen er gjennomsnittstemperaturen til kilden over et år, i °C. Den brukes som utgangspunkt for å beregne varmepumpens sesongytelse. Oppgi den dersom den er kjent, ellers brukes typiske verdier for valgt kilde.',
          liquidMaxTemperature:
            'Dette er den høyeste temperaturen kilden når i løpet av året, i °C. Sammen med årsmiddeltemperatur og amplitude beskriver den hvordan kildetemperaturen svinger gjennom sesongen, noe som påvirker virkningsgraden.',
          sourceTemperatureAmplitude:
            'Temperaturamplituden beskriver hvor mye kildetemperaturen svinger over og under årsmiddelet i løpet av året, i °C. Større amplitude betyr større sesongvariasjon i virkningsgrad. Oppgi den dersom den er kjent, ellers brukes typiske verdier for kilden.',
          energyWellDimensioning:
            'Veiledende verdier for årsmiddeltemperatur og årsamplitude for energibrønner (borehull). Velg beskrivelsen som passer best for bruken og dimensjoneringen av brønnen, så settes temperaturverdiene automatisk ut fra klimastedet.',
          waterSourceDepth:
            'Veiledende verdier for årsmiddeltemperatur og årsamplitude for varmeuttak i sjø og ferskvann. Velg dybden på varmeuttaket, så settes temperaturverdiene automatisk ut fra klimastedet.',
        },
        districtHeating: {
          maxCapacity:
            'Maksimal kapasitet er den høyeste effekten fjernvarme- eller fjernkjølingsanlegget kan levere til bygget, i kW. Oppgi den dersom den er kjent fra dokumentasjon eller anleggsdata. Brukes til å vurdere om kilden dekker effektbehovet.',
          efficiency:
            'Virkningsgraden beskriver hvor stor del av levert energi fra fjernvarmenettet som faktisk blir nyttig varme i bygget, etter tap i veksler og fordeling. Oppgi en samlet verdi dersom du ønsker å overstyre standardverdiene for sentralen.',
          temperatureFromSource:
            'Temperatur fra kilde er turtemperaturen fjernvarme- eller fjernkjølingsnettet leverer inn til varmeveksleren, i °C. Oppgi den hvis den er kjent. Gir en mer realistisk beskrivelse av sentralens drift og virkningsgrad.',
          heatExchangerLoss:
            'Varmeveksleren overfører energi fra fjernvarmenettet til byggets eget system, og litt energi går tapt underveis. Velg isolasjonsnivå og utløpstemperaturområde for å beskrive tapet mer detaljert, eller oppgi tapskoeffisienten direkte dersom en dokumentert verdi finnes. La feltene stå tomme for å bruke standardverdier.',
          distributionHeatLoss:
            'Distribusjonsvarmetap er energien som tapes i rørnettet mellom sentralen og byggets system. Velg tilførselstemperaturområde for distribusjonen for å beskrive tapet mer detaljert, eller oppgi tapskoeffisienten direkte dersom den er kjent. La feltene stå tomme for å bruke standardverdier.',
          coolingHeatExchanger:
            'Kjøleveksleren overfører kjøling fra fjernkjøling eller kjølesentralen til byggets system, og en del energi tapes. Velg isolasjonsnivå dersom kjølesiden skal modelleres mer detaljert, eller oppgi U-verdien direkte dersom den er kjent. La feltene stå tomme for å bruke standardverdier.',
          co2eEmissionFactor:
            'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp som følger med energien fra fjernvarme eller fjernkjøling, oppgitt i gram per kWh. Oppgi en spesifikk verdi dersom du vil bruke nettets faktiske utslippstall. Den påvirker bare utslippsregnskapet, ikke selve energibehovet.',
          energyPrice:
            'Energiprisen er kostnaden per kWh levert energi fra fjernvarme eller fjernkjøling. Oppgi en spesifikk pris dersom du ønsker kostnadsberegninger med reelle priser, ellers kan feltet stå tomt. Påvirker bare kostnadstall, ikke energi eller utslipp.',
        },
        combustionBoiler: {
          boilerType:
            'Kjeltypen beskriver hva slags forbrenningskjel anlegget er, for eksempel olje, gass eller biomasse. Velg den som best beskriver anlegget. Valget styrer standardforutsetninger som virkningsgrad og utslippsnivå.',
          heatingCapacity:
            'Varmekapasiteten er kjelens nominelle varmeeffekt i kW, altså hvor mye effekt den kan levere under normale forhold. Dette er hovedverdien for å vurdere om kjelen dekker effektbehovet.',
          performance:
            'Ytelse angir kjelens nominelle virkningsgradsnivå, altså hvor effektivt brenselet omdannes til nyttig varme. Velg eller oppgi nivå dersom dette er dokumentert for kjelen, ellers brukes standardverdier.',
          fuelSource:
            'Brenselkilden er hva kjelen forbrenner, for eksempel olje, gass eller biobrensel. Valget bestemmer standard energiinnhold og utslippsfaktor for brenselet, og påvirker dermed både energi og utslippsberegning.',
          fuelEnergyContent:
            'Energiinnholdet er hvor mye energi brenselet inneholder per enhet, for eksempel kWh per liter. Oppgi en spesifikk verdi dersom du ønsker mer presise forutsetninger enn standardverdiene for valgt brensel.',
          co2eEmissionFactor:
            'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp forbrenning av brenselet gir, oppgitt i gram per kWh. Oppgi en spesifikk verdi dersom du ønsker en presis utslippsberegning. Den påvirker bare utslippsregnskapet, ikke energibehovet.',
          efficiencyAtLowerLoad:
            'Dette er kjelens varmeeffekt når den kjører på cirka 30 % av full last, oppgitt i kilowatt. Verdien er påkrevd sammen med fullastverdien slik at simuleringen kan modellere kjelens oppførsel på dellast.',
          effectAtFullLoad:
            'Dette er kjelens varmeeffekt ved full last i kilowatt, altså hvor mye effekt den leverer når den kjører på maksimal kapasitet. Verdien er påkrevd for at simuleringen skal dimensjonere kjelen riktig.',
          isCondensing:
            'En kondenserende kjel utnytter også varmen i vanndampen i røykgassen, og oppnår dermed høyere virkningsgrad enn en vanlig kjel. Kryss av dersom kjelen er kondenserende.',
          isCHP:
            'Et kraftvarmeverk (CHP) produserer både elektrisitet og varme samtidig fra samme brensel, noe som gir høy total energiutnyttelse. Kryss av dersom anlegget er et CHP-anlegg, da vises egne CHP-innstillinger.',
          scheduleStart:
            'Starttidspunktet er når kjelens driftssesong begynner, oppgitt som dag og måned. Fyll inn dette dersom kjelen ikke går kontinuerlig eller ikke følger standard driftsprofil, for eksempel en kjel som bare brukes i fyringssesongen.',
          scheduleEnd:
            'Sluttidspunktet er når kjelens driftssesong avsluttes, oppgitt som dag og måned. Fylles ut sammen med starttidspunktet for å beskrive perioden kjelen er i drift.',
          seasonalMeanTemp:
            'Sesongmiddeltemperaturen er gjennomsnittlig utetemperatur over driftssesongen, i °C. Oppgi den dersom anlegget skal beskrives med mer detaljerte temperaturforutsetninger enn standard.',
          temperatureSupply:
            'Turtemperaturen er temperaturen på vannet kjelen sender ut til varmesystemet, i °C. Lavere turtemperatur gir ofte bedre virkningsgrad, særlig for kondenserende kjeler. Oppgi den hvis den er kjent.',
          temperatureReturn:
            'Returtemperaturen er temperaturen på vannet som kommer tilbake til kjelen fra varmesystemet, i °C. For kondenserende kjeler er lav returtemperatur viktig for å oppnå kondensering og høy virkningsgrad. Oppgi den hvis den er kjent.',
        },
        electricBoiler: {
          maxCapacity:
            'Maksimal kapasitet er den høyeste effekten den elektriske kjelen kan levere, i kW. Dette er hovedverdien for å vurdere om kjelen dekker effektbehovet.',
          insulationGrade:
            'Isolasjonsgraden beskriver hvor godt selve kjelen er isolert, og avgjør hvor mye varme den taper til omgivelsene mens den står på. Velg grad dersom du ønsker mer presis modellering av varmetapet fra kjelen.',
          efficiency:
            'Virkningsgraden beskriver hvor stor del av tilført elektrisitet som blir nyttig varme, etter tap i kjelen. Elektriske kjeler har normalt høy virkningsgrad. Oppgi en verdi dersom du ønsker å overstyre standardforutsetningene.',
          co2eEmissionFactor:
            'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp som følger med strømmen kjelen bruker, oppgitt i gram per kWh. Oppgi en spesifikk verdi dersom du ønsker en presis utslippsberegning. Den påvirker bare utslippsregnskapet, ikke energibehovet.',
          temperatureSupply:
            'Turtemperaturen er temperaturen på vannet kjelen sender ut til varmesystemet, i °C. Den påvirker hvilke varmeavgivere kjelen kan betjene og varmetapet i systemet. Oppgi den hvis den er kjent.',
          temperatureReturn:
            'Returtemperaturen er temperaturen på vannet som kommer tilbake til kjelen fra varmesystemet, i °C. Sammen med turtemperaturen beskriver den temperaturnivået i systemet. Oppgi den hvis den er kjent.',
        },
        solarThermal: {
          solarType:
            'Soltypen beskriver kollektorprinsippet, for eksempel plane solfangere eller vakuumrørsolfangere. Vakuumrør gir vanligvis bedre ytelse ved lave utetemperaturer. Valget påvirker standardforutsetningene for anleggets utbytte.',
          azimuth:
            'Asimut er kollektorenes orientering mot himmelretning i grader, der 0 vanligvis betyr rett mot sør. Den beskriver hvilken vei kollektorene vender og påvirker sterkt hvor mye solenergi de fanger.',
          tilt: 'Helningen er kollektorenes vinkel fra horisontalplanet i grader, der 0 er flatt og 90 er loddrett. Sammen med asimut bestemmer den hvor mye solinnstråling kollektorene mottar over året.',
          adjustmentFactor:
            'Justeringsfaktoren skalerer det beregnede solutbyttet opp eller ned for å ta hensyn til lokale forhold som skygge eller tilsmussing. Oppgi en verdi bare dersom du ønsker å korrigere standardberegningen, ellers kan feltet stå tomt.',
          performance:
            'Ytelse angir anleggets nominelle virkningsgrad eller kapasitetsnivå, altså hvor effektivt kollektorene omdanner solinnstråling til nyttig varme. Velg eller oppgi nivå dersom dette er kjent fra dokumentasjon, ellers brukes standardverdier.',
          pipeLength:
            'Rørlengden er samlet lengde på rørene mellom kollektorene og lagringstanken, i meter. Lengre rør gir større varmetap. Oppgi den sammen med rørisolasjonstype dersom du ønsker å beregne rørtap mer detaljert.',
          pipeInsulationType:
            'Rørisolasjonstypen beskriver hvor godt rørene mellom kollektorene og tanken er isolert, noe som setter standard varmetap per meter rør. Velg den hvis kjent, ellers brukes en standardverdi.',
          pipeUValue:
            'U-verdien for rørene angir hvor mye varme rørene i kollektorkretsen taper per meter og grad temperaturforskjell (W/mK). Lavere verdi betyr bedre isolering. Oppgi den dersom den er kjent, ellers utledes den fra valgt rørisolasjonstype.',
          collectorArea:
            'Samlearealet er det totale aktive arealet til solfangerne, i m². Dette er en sentral input for produksjonsberegningen, siden mer kollektorareal gir mer solenergi.',
          tankSpiralPlacementFactor:
            'Plasseringsfaktoren for tankspiralen beskriver hvor i akkumuleringstanken solvarmespiralen er plassert, noe som påvirker hvor effektivt solvarmen overføres til vannet. Oppgi en verdi dersom du har detaljdata for systemet, ellers brukes en standardverdi.',
          temperatureColdWater:
            'Kaldtvannstemperaturen er temperaturen på vannet som tilføres systemet før det varmes opp av solfangerne, i °C. Lavere kaldtvannstemperatur gir høyere solutbytte. Oppgi en verdi dersom du ønsker å overstyre standardverdien.',
          percentageOfCollectorLoopOutside:
            'Dette er hvor stor del av kollektorkretsen (rør og komponenter) som ligger utendørs, i prosent. Rør som ligger ute taper mer varme. Oppgi en verdi dersom dette er relevant for tapsberegningen.',
          collectorSpecs:
            'Disse verdiene utgjør solfangerens virkningsgradskurve, hentet fra produktdatabladet eller Solar Keymark-sertifikatet. η₀ er den optiske virkningsgraden ved ingen temperaturforskjell, mens varmetapskoeffisientene a₁ og a₂ beskriver hvor raskt virkningsgraden faller når kollektoren blir varmere enn omgivelsene. Oppgi verdiene dersom dokumentasjon finnes, ellers brukes standardverdier.',
          snowCoverageMonths:
            'Velg hvilke måneder solfangerne normalt er snødekket. I disse månedene produserer kollektorene lite eller ingen energi, så dette gir en mer realistisk årsberegning der snø påvirker produksjonen.',
          insulationFactorForCollectionLoop:
            'Isolasjonsfaktoren for kollektorkretsen beskriver hvor godt rør og komponenter i solvarmekretsen er isolert samlet sett. Velg nivå dersom du ønsker mer presis beregning av varmetapet i kretsen, ellers brukes en standardverdi.',
        },
        otherSource: {
          fuelType:
            'Brenseltypen er energibæreren denne forsyningen bruker, for eksempel olje, gass, biobrensel, fjernvarme eller elektrisitet. Valget bestemmer standard utslippsfaktor og hvordan energien føres i regnskapet.',
          maxCapacity:
            'Maksimal kapasitet er den høyeste effekten denne energikilden kan levere, i kW. Dette er hovedverdien for å vurdere om kilden dekker effektbehovet.',
          efficiency:
            'Virkningsgraden beskriver hvor stor del av tilført energi som blir nyttig varme eller kjøling, etter tap i kilden. Oppgi en verdi dersom den er kjent, ellers brukes en standardforutsetning.',
          co2eEmissionFactor:
            'CO₂e-utslippsfaktoren angir hvor mye klimagassutslipp som følger med energien denne kilden bruker, oppgitt i gram per kWh. Oppgi en spesifikk verdi dersom du ønsker en presis utslippsberegning. Den påvirker bare utslippsregnskapet, ikke energibehovet.',
          energyPrice:
            'Energiprisen er kostnaden per kWh energi fra denne kilden. Oppgi en spesifikk pris dersom du ønsker kostnadsberegninger med reelle priser, ellers kan feltet stå tomt. Påvirker bare kostnadstall, ikke energi eller utslipp.',
        },
        accumulationTank: {
          purpose:
            'En akkumuleringstank lagrer varme eller kjøling slik at produksjon og forbruk kan forskyves i tid. Velg formål, for eksempel varmelager, kjølelager eller varmtvann, som beskriver hvilken funksjon tanken har i systemet.',
          volume:
            'Volumet er tankens lagringskapasitet i liter, og er hovedparameteren for hvor mye varme eller kjøling tanken kan lagre. Oppgi det dersom akkumuleringstank finnes.',
          insulation:
            'Isolasjonsnivået beskriver hvor godt tanken er isolert, og avgjør hvor mye varme som tapes til omgivelsene. Velg nivå eller type dersom kjent. Brukes til å anslå eller overstyre varmetapet fra tanken.',
          heatLoss:
            'Varmetap (W/K) angir hvor mye effekt tanken taper til omgivelsene per grad temperaturforskjell. Oppgi en dokumentert verdi dersom du har den. Kan normalt stå tomt hvis volum og standard isolasjon er tilstrekkelig.',
          setpoint:
            'Settpunktstemperaturen er ønsket lagringstemperatur i tanken, i °C. Den styrer hvor varmt eller kaldt mediet holdes og påvirker både tap og kapasitet.',
          maxTemp:
            'Maksimaltemperaturen er den høyeste temperaturen tanken tillates å nå, i °C. Oppgi den dersom dette er kjent eller relevant for styringen.',
          minTemp:
            'Minimumstemperaturen er den laveste temperaturen tanken tillates å falle til, i °C. Oppgi den dersom dette er kjent eller relevant for styringen.',
          minTempDhw:
            'Minimumstemperaturen er den laveste temperaturen tanken tillates å falle til, i °C. For tappevannstanker bør den holdes på minst 70 °C for å hindre oppbygging av legionellabakterier.',
        },
      },
      excessEnergy: {
        medium:
          'Mediet er hva overskuddsenergien strømmer i: luft, for eksempel avtrekkskanal, eller væske, for eksempel et spillvannsrør. Valget bestemmer hvilke felter som vises og hvordan tilgjengelig energi beregnes.',
        name: 'Gi overskuddsenergikilden et tydelig navn. Navnet brukes til å identifisere potensielle kilder for gjenvinning, for eksempel avtrekksluft fra et kjøkken eller spillvarme fra en prosess.',
        ductShape:
          'Velg medium og kanalform for kilden. Kanalformen, for eksempel rund eller rektangulær, brukes sammen med målene til å beregne tverrsnittet og dermed tilgjengelig energistrøm når overskuddsenergien tas ut fra luft.',
        ductWidthDiameter:
          'Oppgi bredde eller diameter for kanalen i mm dersom dette er kjent. Brukes sammen med kanalformen, og eventuelt høyde, lufthastighet eller volumstrøm, til å beregne hvor mye luft som strømmer gjennom kanalen.',
        height:
          'Oppgi kanalhøyde i mm dersom kanalformen krever det, for eksempel ved en rektangulær kanal. Sammen med bredden gir den tverrsnittet til kanalen.',
        airspeed:
          'Lufthastigheten er hvor raskt luften strømmer gjennom kanalen, i m/s. Oppgi den dersom volumstrømmen ikke er kjent direkte, da beregnes luftmengden ut fra hastighet og kanalens tverrsnitt.',
        exhaustTempAir:
          'Avtrekkstemperaturen er temperaturen på luftstrømmen overskuddsenergien hentes fra, i °C. Temperaturen er avgjørende for å vurdere hvor mye energi som kan gjenvinnes, høyere temperatur gir mer tilgjengelig varme.',
        exhaustTempLiquid:
          'Oppgi temperaturen på væskestrømmen overskuddsenergien hentes fra, i °C. Temperaturen er avgjørende for å vurdere hvor mye energi som kan gjenvinnes fra væsken.',
        volumeFlowAir:
          'Volumstrømmen er hvor mye luft som passerer per time, i m³/h. Sammen med temperaturen bestemmer den hvor mye energi som er tilgjengelig for gjenvinning. Oppgi den dersom den er kjent, ellers kan den beregnes fra kanalgeometri og lufthastighet.',
        volumeFlowLiquid:
          'Volumstrømmen er hvor mye væske som passerer per time, i L/h. Sammen med temperaturen bestemmer den hvor mye energi som er tilgjengelig for gjenvinning. Oppgi den dersom den er kjent.',
      },
      solarPv: {
        panelAngle:
          'Helningen til solcellepanelene målt fra vannrett, i grader. Et panel som ligger flatt på taket er 0° og et panel som står loddrett er 90°. Helningen avgjør hvor direkte sollyset treffer panelene gjennom året, og påvirker derfor den beregnede årsproduksjonen sterkt.',
        name: 'Et tydelig og gjenkjennelig navn på dette solcelleanlegget. Navnet brukes til å identifisere anlegget i lister, resultater og rapporter, noe som er nyttig når en bygning har flere separate solcelleanlegg.',
        panelArea:
          'Det aktive flatearealet til solcellepanelene, i kvadratmeter. Oppgi enten arealet for ett enkelt panel eller samlet areal for hele anlegget, avhengig av hvordan anlegget registreres, og la Antall stemme med dette valget. Sammen med virkningsgraden er arealet en av de sentrale inngangsverdiene som avgjør hvor mye strøm anlegget kan produsere.',
        quantity:
          'Antall solcellepaneler i anlegget dersom dette er kjent. Det brukes sammen med panelareal og virkningsgrad til å beregne installert kapasitet, og må stemme med hvordan arealet er oppgitt: bruk antall paneler når Panelareal er per panel, og 1 når Panelareal er samlet areal for anlegget.',
        yearInstalled:
          'Året solcelleanlegget ble satt i drift. Det registreres for befaringen, men beregningen bruker det ikke: aldring av panelene regnes alltid over en fast levetid på 30 år, med degraderingstapet per år.',
        soilingLocation:
          'Stedstypen som avgjør hvor raskt støv, pollen og forurensning legger seg på panelene. Når du velger en plassering, for eksempel bynært, landlig eller annen eksponering, lastes en standard månedsprofil for tilsmussing for det miljøet, som du deretter kan finjustere per måned nedenfor.',
        monthlySoiling:
          'Tilsmussing er tapet i produksjon som skyldes skitt, støv, snø og forurensning på paneloverflaten, og det varierer gjennom året. Når du velger en plassering fylles det inn en forenklet standardprofil; oppgi din egen verdi for hver måned her dersom du ønsker å overstyre profilen med stedsspesifikke tall.',
        cellType:
          'Solcelleteknologien i panelene, for eksempel monokrystallinsk eller polykrystallinsk silisium. Solcelletypen avgjør hvor effektivt panelene omdanner sollys til strøm, så valget setter en representativ standard nominell virkningsgrad som du fortsatt kan justere.',
        nominalEfficiency:
          'Andelen av innkommende solenergi som panelene omdanner til strøm under standard testforhold, oppgitt som desimaltall (for eksempel 0,20 for 20 %). Oppgi den dokumenterte verdien fra databladet dersom den er kjent; ellers brukes standardverdien fra valgt solcelletype.',
        panelAzimuth:
          'Himmelretningen panelene vender mot, i grader fra 0 til 360 (sør ligger rundt 180° på den nordlige halvkule). Asimuten avgjør, sammen med helningen, hvor mye av solens bane panelene fanger opp gjennom dagen og året, og påvirker derfor den beregnede produksjonen direkte.',
        shadingFactor:
          'Andelen sollys panelene mister på grunn av skygge fra nabobygg, terreng eller vegetasjon, fra 0 til 1. 0 betyr ingen skygge og 1 betyr helt skyggelagt, så standardverdien 0,05 er et tap på 5 %. Verdien registreres, men beregningen bruker den ikke ennå.',
        mountingType:
          'Hvordan panelene er montert, for eksempel takintegrert eller frittstående med luftspalte. Monteringstypen styrer hvor godt panelene kjøles av omkringliggende luft, noe som inngår i den mer detaljerte modellen for paneltemperatur og tap. Velg den dersom du ønsker dette detaljnivået.',
        windExposure:
          'Hvor eksponert anlegget er for vind. Vind kjøler panelene og senker driftstemperaturen, noe som bedrer virkningsgraden, så dette brukes sammen med monteringstypen i den mer detaljerte modellen for paneltemperatur. Velg den dersom den er kjent.',
        heatLossFactor:
          'Hvor lett panelene avgir varme til omgivelsene, i W/m²K. Den utledes normalt fra monteringstype og vindeksponering, men du kan oppgi en verdi her for å overstyre disse standardforutsetningene og styre hvordan paneltemperaturen modelleres.',
        inverterEfficiency:
          'Andelen av likestrømmen fra panelene som inverteren leverer som brukbar vekselstrøm, som desimaltall (for eksempel 0,945). Den fanger opp omformingstapet i inverteren; oppgi den dokumenterte verdien fra databladet dersom den er kjent.',
        degradationLoss:
          'Den gradvise og varige reduksjonen i panelproduksjon etter hvert som modulene eldes, som desimaltall (for eksempel 0,005 for 0,5 % per år). Oppgi det dersom du ønsker å modellere den reduserte ytelsen over anleggets levetid mer presist.',
        inverterLoss:
          'Ekstra tap knyttet til inverteren og driften av den, som desimaltall. Bruk dette når du ønsker å registrere invertertap separat fra invertervirkningsgraden i stedet for å slå det sammen til ett tall.',
        transmissionProduct:
          'En samlet faktor (0 til 1) for de optiske tapene når lyset passerer gjennom panelets dekkglass og når cellene, som refleksjon og absorpsjon. Oppgi det som desimaltall når valgt beregningsmetode bruker dette leddet.',
        temperatureCoefficient:
          'Hvor mye panelproduksjonen endrer seg med temperaturen, i %/°C. Den er normalt negativ fordi produksjonen synker når panelene varmes opp over temperaturen de er målt ved. Oppgi den dokumenterte verdien fra databladet dersom en slik finnes for panelene.',
        incidentAngleModifier:
          'En faktor (0 til 1) som tar hensyn til de ekstra refleksjonstapene når sollyset treffer panelet skrått i stedet for rett på. Oppgi den som desimaltall dersom du ønsker å bruke den mer detaljerte solmodellen som fanger opp disse innfallsvinkeleffektene.',
      },
      battery: {
        name: 'Et tydelig og gjenkjennelig navn på dette batteriet. Navnet brukes til å identifisere batteriet i lister, resultater og rapporter, noe som er nyttig når et bygg har flere batterier.',
        maxCapacity:
          'Den totale energimengden batteriet kan lagre, i kWh. Dette er batterisystemets oppgitte kapasitet og setter grensen for hvor mye soloverskudd som kan lagres til senere bruk.',
        maxChargePower:
          'Den høyeste effekten batteriet kan lades med, i kW. Den begrenser hvor raskt batteriet kan ta imot soloverskudd eller strøm fra nettet.',
        maxDischargePower:
          'Den høyeste effekten batteriet kan levere tilbake til bygget, i kW. Den begrenser hvor mye av byggets last batteriet kan dekke i hvert øyeblikk.',
        chargeEfficiency:
          'Hvor stor andel av energien som sendes inn i batteriet som faktisk lagres, mellom 0 og 1. La verdien stå på 0 for å bruke en typisk standardverdi for litiumionbatterier.',
        dischargeEfficiency:
          'Hvor stor andel av den lagrede energien som faktisk leveres når batteriet lades ut, mellom 0 og 1. La verdien stå på 0 for å bruke en typisk standardverdi for litiumionbatterier.',
        minStateOfCharge:
          'Det laveste nivået batteriet får lades ut til, som andel av full kapasitet mellom 0 og 1. En reserve beskytter batteriets levetid. La verdien stå på 0 for å bruke standardverdien.',
        maxStateOfCharge:
          'Det høyeste nivået batteriet får lades opp til, som andel av full kapasitet mellom 0 og 1. Å lade litt under fullt beskytter batteriets levetid. La verdien stå på 0 for å bruke standardverdien.',
        peakShavingThreshold:
          'Nettimporten batteriet prøver å holde bygget under, i kW. Når bygget ellers ville trukket mer enn dette fra nettet, lades batteriet ut for å dekke differansen. La verdien stå på 0 for å slå av kutting av effekttopper; batteriet lagrer da bare soloverskudd og dekker underskudd.',
        preChargeStateOfCharge:
          'Nivået batteriet forhåndslades til fra nettet i rolige timer, som andel av full kapasitet mellom 0 og 1, slik at det er klart til neste effekttopp. Brukes bare når en grense for effekttopper er satt. La verdien stå på 0 for å slå av forhåndslading.',
      },
    },
  },

  // Page titles
  title: 'Befaringer',
  sidebarTitle: 'Befaring',
  new: 'Ny befaring',
  edit: 'Rediger befaring',

  // List page
  fetchError: 'Kunne ikke hente befaringer.',
  noInspections: 'Ingen befaringer funnet.',
  createNew: 'Ny befaring',
  confirmDeleteTitle: 'Slett befaringer',
  confirmDeleteDescription:
    'Er du sikker på at du vil slette denne befaringen?',
  duplicate: 'Dupliser',
  duplicating: 'Dupliserer befaring...',
  duplicateSuccess: 'Befaring duplisert',
  duplicateError: 'Kunne ikke duplisere befaring',
  renameInspection: 'Gi nytt navn til befaringen',

  // Common
  common: {
    // generic
    custom: 'Egendefinert',
    standard: 'Standard',
    other: 'Annet',
    text: 'Tekst',
    from: 'Fra',
    to: 'Til',
    hide: 'Skjul',
    show: 'Vis',
    horizontal: 'Vannrett',
    vertical: 'Loddrett',
    addImage: 'Legg til bilde',
    confirmDeleteImage: 'Er du sikker på at du vil slette dette bildet?',
    generating: 'Genererer...',
    indoorClimate: 'Inneklima',
    score: 'Score',
    energyData: 'Energidata',
    air: 'Luft',
    liquid: 'Væske',
    round: 'Rund',
    square: 'Firkantet/rektangulær',

    // field labels
    quantity: 'Antall',
    location: 'Lokasjon',
    priority: 'Prioritet',
    yearInstalled: 'Installasjonsår',
    medium: 'Medium',

    // section / navigation labels
    inspection: 'Befaring',
    info: 'Informasjon',
    purpose: 'Formål',
    module: 'Modul',
    control: 'Styring & Regulering',
    equipment: 'Utstyr',
    hvacSystems: 'HVAC Systemer',
    thermalZones: 'Termiske soner',
    zones: 'Soner',
    heatingCooling: 'Oppvarming & kjøling',
    heatingAndCooling: 'Oppvarming og kjøling',
    heatingOnly: 'Kun oppvarming',
    domesticHotWater: 'Tappevann',
    centralEnergy: 'Sentral energi',
    excessEnergy: 'Overskuddsenergi',
    solarPv: 'Solceller',
    solarThermal: 'Soltermisk',
    solarCells: 'Solceller',
    attachments: 'Vedlegg',
    annualSimulation: 'Årssimulering',
    energyLabel: 'Energimerke',
    actions: 'Tiltak',
    lighting: 'Belysning',
    report: 'Rapport',
    hvac: 'HVAC',
    windows: 'Vinduer',
    doors: 'Dører',
    gates: 'Porter',
    walls: 'Vegger',
    exteriorWalls: 'Yttervegger',
    floor: 'Gulv mot grunn',
    roof: 'Yttertak',
    basement: 'Kjellerkonstruksjon',
    groundConditions: 'Grunnforhold',
    airLeakage: 'Luftlekkasje',
    thermalMass: 'Termisk masse',
    internalLoads: 'Interne laster',
    productionEquipment: 'Produksjonsutstyr',
    ground: 'Jord',
    zone: 'Sone',
    wall: 'Vegg',
    window: 'Vindu',
    door: 'Dør',
    gate: 'Port',

    // climate
    climate: 'Klima',
    climatized: 'Klimatisert',
    partlyClimatized: 'Delvis klimatisert',
    unclimatized: 'Ikke klimatisert',
    floorHeight: 'Etasjehøyde (m)',

    // units and physical quantities
    area: 'Areal (m²)',
    areaShort: 'Areal',
    volume: 'Volum (L)',
    volumeShort: 'Volum',
    length: 'Lengde (m)',
    power: 'Effekt (kW)',
    powerShort: 'Effekt',
    uValue: 'U-verdi (W/m²K)',
    uValueShort: 'U-verdi',
    coverageArea: 'Dekningsareal (m²)',
    coverageAreaShort: 'Dekningsareal',
    coverageVolume: 'Dekningsvolum',
    heatingEffect: 'Varmeeffekt (kW)',
    coolingEffect: 'Kjøleeffekt (kW)',
    effect: 'Effekt (kW)',
    cop: 'COP',
    eer: 'EER',
    seasonalCOP: 'Sesong-COP',
    seasonalEER: 'Sesong-EER',
    efficiency: 'Virkningsgrad',
    systemEfficiency: 'Systemvirkningsgrad (%)',
    co2eEmissionFactor: 'CO₂e-utslippsfaktor (g/kWh)',
    temperatureSupply: 'Turtemperatur (°C)',
    temperatureReturn: 'Returtemperatur (°C)',
    avgTemp: 'Snittemp',
    sfp: 'SFP',
    bra: 'BRA',
    airVolume: 'Luftmengde',
    heatRecovery: 'Varmegjenvinning',
    panelArea: 'Panelareal',
    cellType: 'Solcelletype',
    azimuth: 'Asimut',
    value: 'Verdi',
    unit: 'Enhet',

    // system / fuel
    systemType: 'Systemtype',
    systemTypeShort: 'Systemtype',
    energySource: 'Energikilde',
    energySourceShort: 'Energikilde',
    specificFuelType: 'Spesifikt brensel',
    selectSpecificFuelType: 'Velg spesifikt brensel...',
    inverterControlled: 'Inverterkontrollert',
    nominalLoad: 'Nominell last',
    minimumLoad: 'Minimum last',
    degradeCoeff: 'Degraderingskoeff',
    heatPump: 'Varmepumpe',
    electric: 'Elektrisk',
    oil: 'Olje',
    gas: 'Gass',
    rock: 'Fjell',
    coolingOnly: 'Kun kjøling',

    // performance / magnitude grades
    high: 'Høy',
    low: 'Lav',
    normal: 'Normal',

    // dimensions
    width: 'Bredde (m)',
    height: 'Høyde (m)',
    depth: 'Dybde (m)',

    // zone editor
    userDefined: 'Brukerdefinert',
    calculator: 'Kalkulator',
    compass: {
      N: 'N',
      NE: 'NØ',
      E: 'Ø',
      SE: 'SØ',
      S: 'S',
      SW: 'SV',
      W: 'V',
      NW: 'NV',
    },
    directions: {
      n: 'Nord (0°)',
      ne: 'Nordøst (45°)',
      e: 'Øst (90°)',
      se: 'Sørøst (135°)',
      s: 'Sør (180°)',
      sw: 'Sørvest (225°)',
      w: 'Vest (270°)',
      nw: 'Nordvest (315°)',
    },
    structuralNodes: 'Strukturelle noder',
    structuralNode: 'Strukturell node',
    addStructuralNode: 'Legg til strukturell node',
    copyStructuralNode: 'Kopier strukturell node',
    confirmDeleteStructuralNode: 'Slette denne strukturelle noden?',
    boundary: 'Grense',
    boundaryInteriorAir: 'Innerluft',
    boundaryExterior: 'Yttervegg',
    boundaryAdjacentZone: 'Tilstøtende sone',
    boundaryAdiabatic: 'Adiabatisk',
    node: 'Node',
    addNode: 'Legg til node',
    copyNode: 'Kopier node',
    confirmDeleteNode: 'Slette denne noden?',
    surfaceType: 'Overflatetype',
    surfaceCeiling: 'Himling',
    surfaceArea: 'Overflateareal (m\u00B2)',
    heatTransferCoeff: 'Varmeovergangskoeff. (W/m\u00B2K)',
    totalMass: 'Total masse (kg/m\u00B3)',
    specificHeatCapacity: 'Spesifikk varmekapasitet (J/kgK)',

    // insulation grades
    insulated: 'Isolert',
    uninsulated: 'Uisolert',
    poorlyInsulated: 'Dårlig isolert',
    normallyInsulated: 'Normalt isolert',
    wellInsulated: 'Godt isolert',
    veryWellInsulated: 'Svært godt isolert',
    selectInsulation: 'Velg isolasjon...',
    selectPerformance: 'Velg ytelse...',
    selectFuelType: 'Velg brenseltype...',

    // UI layout
    basicSettings: 'Grunninnstillinger',
    additionalInfo: 'Tilleggsinformasjon',
    showAdvanced: 'Vis avansert',
    hideAdvanced: 'Skjul avansert',
    advanced: 'Avansert',

    // actions (formerly actions.common)
    settingUp: 'Setter opp...',
    co2PerKwh: 'CO₂ per kWh [g]',
    gridFee: 'Nettleie [NOK/kWh]',
    enovaSupport: 'Enova støtte [%]',
    descriptionPlaceholder:
      'Beskriv tiltaket i detalj: hva endres, hvorfor, og forventet resultat. Inkluder en beregning av antatt redusert energibruk dersom tiltaket gjennomføres, samt en vurdering av kostnader og konsekvenser mht. fukt og inneklima knyttet til tiltaket.',
    electricityZone: 'Strømsone',
    selectZone: 'Velg en sone...',
    runSimulation: 'Kjør byggsimulering',
    runningSimulation: 'Kjører simulering...',
    simulationDescription: 'Kjører timesbasert energibalansesimulering',
    baselineProgress: 'Kjører referansesimulering... (1/2)',
    actionProgress: 'Kjører tiltakssimulering... (2/2)',
    baselineStarted: 'Basissimulering startet...',
    simulationStarted: 'Tiltakssimulering startet...',
    noAnnualSimulation:
      'Kjør en årlig simulering først for å aktivere sammenligning av tiltak.',
    simulationResults: 'Simuleringsresultater',
    lastSimulated: 'Sist simulert',
    nettEnergyDemand: 'Netto energibehov',
    energyCategory: 'Energikategori',
    baselineKwh: 'Referanse (kWh)',
    actionKwh: 'Tiltak (kWh)',
    savingsKwh: 'Besparelse (kWh)',
    baselineKwhM2: 'Referanse (kWh/m²)',
    actionKwhM2: 'Tiltak (kWh/m²)',
    savingsPercent: 'Besparelse (%)',
    baseline: 'Referanse',
    afterAction: 'Etter tiltak',
    solarProduction: 'Solproduksjon',
    savings: 'Besparelse',
    costSavings: 'Kostnad og besparelse',
    annualEnergySavings: 'Årlig energibesparelse',
    kwhYear: 'kWh/år',
    energySavingsTooltip: 'Reduksjon i totalt energibehov fra forbedringer',
    reduction: 'reduksjon',
    increase: 'økning',
    annualCostSavings: 'Årlig kostnadsbesparelse',
    nokYear: 'NOK/år',
    costSavingsTooltip:
      'Total kostnadsbesparelse fra redusert energiforbruk og inntekt fra eksportert solproduksjon',
    netCo2Reduction: 'Netto CO₂-reduksjon',
    kgCo2Year: 'kg CO₂/år',
    co2Tooltip: 'Bruker {value} g CO₂/kWh',
    tonnes: 'tonn',
    paybackPeriod: 'Tilbakebetalingstid',
    paybackTooltip: 'Tid for å tjene tilbake investeringen',
    years: 'år',
    investmentLabel: 'Investering: {value} NOK',
    noInvestmentCost: 'Ingen investeringskostnad angitt',
    beforeExisting: 'Før - Eksisterende anlegg',
    afterNew: 'Etter - Nytt anlegg',
    investment: 'Investering',
    installationType: 'Installasjonstype',
    simple: 'Enkel',
    complex: 'Kompleks',
    deliveredEnergy: 'Levert energi',
    roiTitle: 'Avkastning over tid',
    roiCumulativeSavings: 'Kumulativ besparelse',
    roiNetValue: 'Nettoverdi (etter investering)',
    roiYears: 'År',
    roiBreakEven: 'Nullpunkt nås når nettoverdien passerer null (år {value})',

    // misc
    presenceControl: 'Tilstedeværelseskontroll',
    distributionLosses: 'Distribusjons- og akkumuleringstap',
    installationCost: 'Installasjonskostnad [NOK]',
    installationCostShort: 'Installasjonskostnad',
    noZones:
      'Ingen termiske soner funnet. Legg til termiske soner i seksjonen for termiske soner først.',

    // shared energy source labels
    energySources: {
      electricity: 'Elektrisitet',
      heatpumpAirToAir: 'Varmepumpe luft-til-luft',
      fossilOil: 'Fossil olje',
      fossilGas: 'Fossil gass',
      fossilSolidFuel: 'Fossilt fast brensel',
      bioOil: 'Bioolje',
      bioGas: 'Biogass',
      bioSolidFuel: 'Bio fast brensel',
      districtHeating: 'Fjernvarme',
      districtCooling: 'Fjernkjøling',
      otherSources: 'Andre kilder',
    },

    // shared schedule block
    schedule: {
      operationalSchedule: 'Driftsplan',
      addSchedule: 'Legg til driftsplan',
      clickToToggle: 'Klikk på timer for å slå av/på',
      avgTemp: 'Snittemp',
      days: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn'],
      months: [
        'Januar',
        'Februar',
        'Mars',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Desember',
      ],
      hours: 'Timer',
      weekly: 'Ukentlig',
      annual: 'Årlig',
      on: 'PÅ',
      off: 'AV',
      hoursPerDayUnit: 't/dag',
      hoursPerWeekUnit: 't/uke',
      hoursPerYearUnit: 't/år',
      setpointPerHour: 'Settpunkttemperatur per time',
      setpointInfoTooltip:
        'Bruk PÅ/AV for å styre driftstimer. Settpunktverdier for PÅ-timer brukes i beregninger. AV-timer er utenfor drift.',
      copyToWeekdays: 'Kopier til ukedager',
      copyToWeekends: 'Kopier til helg',
      resetToStandards: 'Tilbakestill til',
      confirmDeleteSchedule: 'Slette denne driftsplanen?',
      fromMonth: 'Fra',
      toMonth: 'Til',
    },
  },

  // List page labels
  lists: {
    quantity: 'Antall',
    totalArea: 'Totalt (m²)',
    thermalZones: {
      duplicateZone: 'Dupliser sone',
      copySuffix: 'kopi',
      duplicateSuccess: 'Sone duplisert',
      duplicateError: 'Kunne ikke duplisere sone',
    },
    exteriorWalls: {
      addFirst: 'Klikk for å legge til din første yttervegg',
      addWall: 'Legg til vegg',
      duplicateWall: 'Dupliser vegg',
    },
    windows: {
      addFirst: 'Klikk for å legge til ditt første vindu',
      addWindow: 'Legg til vindu',
    },
    doors: {
      addFirst: 'Klikk for å legge til din første dør',
      addDoor: 'Legg til dør',
    },
    gates: {
      addFirst: 'Klikk for å legge til din første port',
      addGate: 'Legg til port',
    },
    productionEquipment: {
      addFirst: 'Klikk for å legge til ditt første produksjonsutstyr',
      addEquipment: 'Legg til produksjonsutstyr',
    },
    hvac: {
      addFirst: 'Klikk for å legge til din første HVAC-enhet',
      addHvac: 'Legg til HVAC',
    },
    heatingCooling: {
      addFirstHeating: 'Klikk for å legge til et varme- eller kjølesystem',
      addHeating: 'Legg til system',
    },
    domesticHotWater: {
      add: 'Legg til tappevann',
      addFirst: 'Klikk for å legge til tappevann',
    },
    centralEnergy: {
      add: 'Legg til sentral energimodul',
      addFirst: 'Klikk for å legge til en sentral energimodul',
    },
    excessEnergy: {
      add: 'Legg til overskuddsenergimodul',
      addFirst: 'Klikk for å legge til en overskuddsenergimodul',
    },
    solarPv: {
      add: 'Legg til solcellemodul',
      addFirst: 'Klikk for å legge til en solcellemodul',
    },
    batteries: {
      add: 'Legg til batteri',
      addFirst: 'Klikk for å legge til et batteri',
    },
    attachments: {
      noInspectionFound: 'Ingen befaring funnet',
    },
  },

  // Edit page - Form fields
  inspector: 'Inspektør',
  selectBuilding: 'Velg bygning',
  selectedBuilding: 'Bygning',
  selectBuildingPlaceholder: 'Velg bygning...',
  notes: 'Notater',

  // Edit page - Map panel
  advancedComingSoon: 'Under utvikling',
  mapPlaceholder: 'Sastech Kart',

  // Status options
  statusDraft: 'Utkast',
  statusInReview: 'Under vurdering',
  statusCompleted: 'Fullført',

  // Validation & feedback
  buildingRequired: 'Vennligst velg en bygning',
  gpsRequired: 'Den valgte bygningen må ha en GPS-posisjon',
  createSuccess: 'Befaring opprettet',
  updateSuccess: 'Befaring oppdatert',
  saved: 'lagret',
  saveError: 'Kunne ikke lagre befaring',
  loadError: 'Kunne ikke laste befaringsdata',

  // Delete dialog
  deleteTitle: 'Slett befaring',
  deleteConfirm: 'Er du sikker på at du vil slette denne befaringen?',
  deleteSuccess: 'Befaring slettet',
  deleteError: 'Kunne ikke slette befaring',

  // Zone edit
  zoneName: 'Sonenavn',
  zoneCategory: 'Sonekategori',
  buildingSubcategory: 'Bygningsunderkategori',
  zoneSaved: 'Sone lagret',
  standardElementsUpdated: 'Oppdaterte {count} elementer til {tek}',
  braRequired: 'BRA over 0 er påkrevd',
  basementAreaRequired: 'Gulvareal for kjeller større enn 0 er påkrevd',
  categoryRequired: 'Vennligst velg en bygningskategori',
  yearRequired: 'Vennligst oppgi byggeår',
  floorsRequired: 'Vennligst oppgi antall etasjer',
  zoneCategoryRequired: 'Vennligst velg en sonekategori',
  subcategoryRequired: 'Vennligst velg en bygningsunderkategori',
  zoneClimateRequired: 'Vennligst velg et soneklima',
  floorHeightRequired: 'Etasjehøyde større enn 0 er påkrevd',
  airLeakageN50Required: 'Lekkasjetall (n50) større enn 0 er påkrevd',
  thermalBridgePsiRequired: 'Normalisert kuldebroverdi er påkrevd',
  panelAreaRequired: 'Panelareal større enn 0 er påkrevd',
  yearInstalledRequired: 'Installasjonsår er påkrevd',
  soilingLocationRequired: 'Vennligst velg en plassering for tilsmussning',
  cellTypeRequired: 'Vennligst velg en solcelletype',
  deleteZone: 'Slett sone',
  deleteZoneWarning: 'Denne handlingen kan ikke angres',
  confirmDeleteZone: 'Slette denne sonen?',
  indoorTemp: 'Starttemperatur (°C)',
  zoneClimate: 'Soneklima',
  thermalBridgeCoeff: 'Bærekonstruksjon (kuldebro)',
  thermalBridgePsiValue: 'Normalisert kuldebroverdi ψ (W/(m²·K))',
  thermalBridgeCoeffTypes: {
    custom: 'Egendefinert',
    wood: 'Bygning med bæresystem i tre',
    concrete_10cm:
      'Bygning med bæresystem i betong, mur eller stål og 10 cm kuldebrobryter i fasadene',
    concrete_5cm:
      'Bygning med bæresystem i betong, mur eller stål og 5 cm kuldebrobryter i fasadene',
  },
  addZone: 'Legg til sone',
  addFirstZone: 'Klikk for å legge til din første sone',
  image: 'Bilde',
  upload: 'Last opp',

  // Heating/Cooling edit pages
  heatingCooling: {
    deleteModule: 'Slett modul',
    confirmDeleteModule: 'Slette denne modulen?',
    deleteHeating: 'Slett varmemodul',
    deleteCooling: 'Slett kjølemodul',
    confirmDeleteHeating: 'Slette denne varmemodulen?',
    confirmDeleteCooling: 'Slette denne kjølemodulen?',
    systemType: 'Type',
    priorityHelp: '1 = høyeste prioritet (dekker behov først)',
    maxTemperatureSupplied: 'Maks turtemperatur (°C)',
    systemTypeRequired: 'Vennligst velg en systemtype',
    energySourceRequired: 'Vennligst velg en energikilde',
    heatingEffectRequired: 'Varmeeffekt større enn 0 er påkrevd',
    coolingEffectRequired: 'Kjøleeffekt større enn 0 er påkrevd',
    systemEfficiencyRequired: 'Systemvirkningsgrad større enn 0 er påkrevd',
    copRequired: 'COP større enn 0 er påkrevd',
    eerRequired: 'EER større enn 0 er påkrevd',
  },

  domesticHotWater: {
    deleteDhw: 'Slett tappevann',
    confirmDelete: 'Slette denne tappevannmodulen?',
    heaterType: 'Varmertype',
    volume: 'Volum (L)',
    setpointTemperature: 'Settpunkttemperatur (°C)',
    heatingElementPower: 'Varmeelementeffekt (kW)',
    heaterTypes: {
      electric: 'Elektrisk',
      centralHeating: 'Sentralvarme',
    },
    typeSection: 'Type',
    consumptionSection: 'Forbruk',
    distributionSection: 'Distribusjonssystem',
    greyWaterSection: 'Gråvanns varmegjenvinning',
    tapFrequency: 'Tappefrekvens',
    tapCyclesPerDay: 'Tappesykluser per døgn',
    hasCirculation: 'Varmtvannssystem med sirkulasjon',
    pipeSpecificLength: 'Spesifikk lengde varmtvannsrør',
    circulationPipeLength: 'Spesifikk lengde sirkulasjonsrør',
    greyWaterRecoveryType: 'Gjenvinnertype',
    greyWaterEfficiencyGrade: 'Momentan virkningsgrad',
    greyWaterShareType: 'Andel tappevann til gjenvinning',
    greyWaterConnectionType: 'Tilkoblingsvariant',
    greyWaterPatternType: 'Tappemønster',
    greyWaterHelperText:
      'Gjenvunnet energi fra gråvann trekkes fra det totale energibehovet for oppvarming av tappevann.',
    tapFrequencyTypes: {
      high: 'Høy tappefrekvens',
      normal: 'Normal tappefrekvens',
      low: 'Lav tappefrekvens',
      perDay: '/døgn',
    },
    dhwPipeLengthTypes: {
      residentialLong: 'Bolig, lange rørstrekk',
      residentialNormal: 'Bolig, normale rørstrekk',
      residentialShort: 'Bolig, korte rørstrekk',
      commercialLong: 'Næringsbygg, lange rørstrekk',
      commercialNormal: 'Næringsbygg, normale rørstrekk',
      commercialShort: 'Næringsbygg, korte rørstrekk',
    },
    circulationPipeLengthTypes: {
      circulationLong: 'Sirkulasjonssystem, lange rørstrekk',
      circulationNormal: 'Sirkulasjonssystem, normale rørstrekk',
      circulationShort: 'Sirkulasjonssystem, korte rørstrekk',
    },
    greyWaterRecoveryTypes: {
      verticalPipe: 'Vertikalt rør-varmeveksler',
      horizontalPipe: 'Horisontal varmeveksler',
      tankRecovery: 'Tankbasert varmegjenvinning',
    },
    greyWaterEfficiencyGrades: {
      low: 'Lav virkningsgrad',
      normal: 'Normal virkningsgrad',
      high: 'Høy virkningsgrad',
    },
    greyWaterShareTypes: {
      allShowers: 'Alle dusjer til gjenvinning',
      halfShowers: '50 % av dusjer til gjenvinning',
      thirdShowers: '30 % av dusjer til gjenvinning',
    },
    greyWaterConnectionTypes: {
      hotWaterTankOnly: 'Koblet til varmtvannstank',
      coldWaterShowerOnly: 'Koblet til kaldtvannsdusjkrets',
      hotWaterTankAndColdWaterShower:
        'Koblet til varmtvannstank og kaldtvannsdusjkrets',
    },
    greyWaterPatternTypes: {
      residentialWithAccumulation: 'Bolig med gråvannsakkumulering',
      residentialWithoutAccumulation: 'Bolig uten gråvannsakkumulering',
      showerWithoutAccumulation: 'Dusjfasilitet uten gråvannsakkumulering',
      showerWithAccumulation: 'Dusjfasilitet med gråvannsakkumulering',
    },
  },

  // Pipe Link configuration
  pipeLink: {
    localEnergySources: 'Lokale energikilder',
    centralEnergySources: 'Sentrale energikilder',
    noCentralModules: 'Ingen sentrale energimoduler konfigurert',
    pipeConfiguration: 'Rørkonfigurasjon',
    spp: 'SPP (kW/(l/s))',
    constantFlow: 'Konstant strømning',
    variableFlow: 'Variabel strømning',
    lengthOfPipe: 'Rørlengde (m)',
    percentageInHeatedSpace: '% i oppvarmet rom',
    avgTempOutsideHeatedSpace: 'Snitttemp. utenfor oppvarmet rom (°C)',
    // Dropdown labels
    waterSystemQuality: 'Vannfordeling kvalitet',
    waterDistributionType: 'Vannbåren distribusjonstype',
    pipeInsulationType: 'Rørisolasjon',
    // Water system quality options (NS 3031:2025 Table E.1)
    qualityOptions: {
      poor: 'Dårlig vannfordeling',
      normal: 'Normal vannfordeling',
      good: 'God vannfordeling',
    },
    // Water distribution system types (NS 3031:2025 Table E.1)
    distributionTypes: {
      radiatorFloorHeating: 'Varmeanlegg, radiatorer/gulvvarme',
      heatingBattery: 'Varmeanlegg, varmebatteri i ventilasjon',
      localCoolingCeilingBaffles: 'Kjøleanlegg, lokal kjøling/himlingsbafler',
      centralCoolingBattery: 'Kjøleanlegg, sentralt kjølebatteri i ventilasjon',
      dhwCirculation: 'VVS sirkulasjon',
      energyWellBrine: 'Energibrønn, brine',
    },
    // Pipe insulation types (NS 3031:2025 Table H.2)
    insulationTypes: {
      uninsulated: 'Uisolerte rør',
      poorlyInsulated: 'Dårlig isolerte rør',
      normallyInsulated: 'Normalt isolerte rør',
      wellInsulated: 'Godt isolerte rør',
      veryWellInsulated: 'Meget godt isolerte rør',
    },
    // Distribution pipe length type (NS 3031:2025 Table H.1)
    distributionPipeLengthType: 'Løpemeter rør per BRA',
    distributionPipeLengthTypes: {
      localAndCentralLong: 'Både lokal og sentral oppvarming, lange rørstrekk',
      localAndCentralNormal:
        'Både lokal og sentral oppvarming, normalt lange rørstrekk',
      centralOnlyLong: 'Kun sentral oppvarming, lange rørstrekk',
      centralOnlyShort: 'Kun sentral oppvarming, korte rørstrekk',
    },
    temperatureCannotBeZero: 'Temperatur kan ikke være 0',
    pipeTemperatureZeroWarning: 'Tur og/eller returtemperatur er satt til 0.',
  },

  // Production Equipment edit page
  productionEquipment: {
    deleteEquipment: 'Slett produksjonsutstyr',
    confirmDelete: 'Slette dette produksjonsutstyret?',
    eligibleForHarvesting: 'Kvalifisert for energigjenvinning',
    eligibleForHarvestingHelp:
      'Marker dette utstyret som kvalifisert for gjenvinning av overskuddsenergi',
  },

  // Central Energy Module
  centralEnergy: {
    // Basic settings
    mode: 'Modus',
    heatPumpTypeRequired: 'Hver varmepumpe trenger en varmepumpetype',
    heatPumpNominalLoadRequired:
      'Hver varmepumpe trenger en nominell last større enn 0',
    heatPumpMinimumLoadRequired:
      'Hver varmepumpe trenger en minimum last større enn 0',
    combustionBoilerTypeRequired: 'Hver forbrenningskjel trenger en kjeltype',
    combustionBoilerFuelSourceRequired:
      'Hver forbrenningskjel trenger en brenselkilde',
    fillRequiredFields: 'Fyll ut alle påkrevde felt',
    requiredFieldsNotSaved:
      'Endringer lagres ikke før alle påkrevde felt er fylt ut',
    solarThermalSolarTypeRequired: 'Hver soltermisk kilde trenger en soltype',
    solarThermalCollectorAreaRequired:
      'Hver soltermisk kilde trenger et samleareal større enn 0',
    otherSourceMaxCapacityRequired:
      'Hver annen kilde trenger en maks kapasitet større enn 0',
    otherSourceEfficiencyRequired:
      'Hver annen kilde trenger en virkningsgrad større enn 0',
    heatingAndHotWater: 'Oppvarming og varmtvann',
    thermalZone: 'Termisk sone',
    thermalZoneHelp: 'Koble til termisk sone for omgivelsestemperatur',
    noZone: 'Ingen (frittstående)',
    selectZone: 'Velg sone...',
    ambientTemperature: 'Omgivelsestemperatur',
    ambientTempHelp:
      'Temperatur rundt modulen når den ikke er koblet til en sone',
    moduleName: 'Sentral energimodul',
    deleteModule: 'Slett sentral energimodul',
    confirmDelete: 'Slette denne sentrale energimodulen og alle energikildene?',
    notLinkedWarning:
      'Denne modulen er ikke koblet til noe utstyr. Legg den til som energikilde i oppvarming/kjøling, ventilasjon, varmtvann eller produksjonsutstyr.',
    notLinkedListWarning:
      '{name} er ikke koblet til noe utstyr. Legg den til som energikilde for å bruke den.',
    notesAttachments: 'Notater og vedlegg',
    energySources: 'Energikilder',
    tanks: 'Tanker',
    performance: 'Ytelse',

    // Accumulation tanks
    accumulationTanks: 'Akkumuleringstanker',
    addTank: 'Legg til tank',
    confirmDeleteTank: 'Slette denne akkumuleringstanken?',
    noTanks: 'Ingen akkumuleringstanker konfigurert. Klikk for å legge til.',
    dhwTank: 'VVT (varmtvann)',
    heatingTank: 'Varmebuffer',
    coolingTank: 'Kjølelager',
    insulation: 'Isolasjon',
    setpoint: 'Settpunkt (°C)',
    maxTemp: 'Maks temp (°C)',
    minTemp: 'Min temp (°C)',
    heatLoss: 'Varmetap (W/K)',

    // Electric boiler insulation (Table J.2)
    boilerInsulation: 'Isolasjonsgrad kjel',
    boilerInsulationVeryLow: 'Meget dårlig isolert',
    selectBoilerInsulation: 'Velg isolasjon...',

    // Energy source configuration
    energySourceConfig: 'Energikildekonfigurasjon',
    sourceType: 'Energikildetype',
    selectType: 'Velg energikildetype...',
    sourceName: 'Energikildenavn',
    usage: 'Bruk',
    dhw: 'VVT',
    addToList: 'Legg til i listen',

    // Priority list
    priorityList: 'Prioritetsliste',
    dragToReorder: 'Trykk for å redigere. Dra for å endre rekkefølge',
    clickToEdit: 'Klikk på en kilde for å redigere',
    confirmDeleteSource: 'Slette denne energikilden?',
    noPrioritySources: 'Ingen energikilder lagt til ennå',
    noSources:
      'Ingen energikilder lagt til ennå. Bruk skjemaet over for å legge til kilder.',

    // Energy source types
    districtHeating: 'Fjernvarme',
    combustionBoiler: 'Forbrenningskjel',
    electricBoiler: 'Elektrisk kjel',
    otherSource: 'Annen kilde',

    // Heat pump fields
    heatPumpType: 'Varmepumpetype',
    airToAir: 'Luft-til-luft',
    airToWater: 'Luft-til-vann',
    liquidToWater: 'Væske-til-vann',
    heatingCapacity: 'Varmekapasitet (kW)',
    liquidSource: 'Væskekilde',
    selectSource: 'Velg kilde...',
    freshWater: 'Ferskvann',
    seaWater: 'Sjøvann',
    sourceTemp: 'Kildetemperatur (°C)',
    avgYearlyTemp: 'Årsmiddeltemperatur (°C)',
    maxTemperatureSupplied: 'Høyeste leverte temperatur (°C)',
    SourceTempeAmplitude: 'Sesongvariasjon (Amplitude) (°C)',
    energyWellDimensioning: 'Bruk og dimensjonering av energibrønn',
    energyWellHeatingOnlyUndersized:
      'Kun oppvarming (varmeuttak), noe underdimensjonert energibrønn',
    energyWellHeatingOnlyGood:
      'Kun oppvarming (varmeuttak), godt dimensjonert energibrønn',
    energyWellSomeCoolingUndersized:
      'Oppvarming og noe kjøling, noe underdimensjonert energibrønn',
    energyWellSomeCoolingGood:
      'Oppvarming og noe kjøling, godt dimensjonert energibrønn',
    energyWellBalancedUndersized:
      'Balansert oppvarming og kjøling, noe underdimensjonert energibrønn',
    energyWellBalancedGood:
      'Balansert oppvarming og kjøling, godt dimensjonert energibrønn',
    highestSourceTemperature: 'Høyeste leverte kildetemperatur (°C)',
    waterSourceDepth: 'Dybde på varmeuttak i sjø/vann',
    CO2EmissionFactor: 'CO₂-utslippsfaktor (g/kWh)',

    // District heating / Electric boiler / Other source fields
    maxCapacity: 'Maks kapasitet (kW)',
    energyPrice: 'Energipris (per kWh)',
    temperatureFromSource: 'Temperatur fra kilde (°C)',
    // Combustion boiler fields
    boilerType: 'Kjeltype',
    biomass: 'Biomasse',
    fuelSource: 'Brenselkilde',
    otherFuelSource: 'Annet',
    fuelType: 'Brenseltype',
    flueGasCondensation: 'Røykgasskondensering',
    fuelConfig: 'Drivstoffkonfigurasjon',
    fuelEnergyContent: 'Energiinnhold (kWh/L)',
    efficiencyLowLoad: 'Effekt ved 30% last (kW)',
    effectFullLoad: 'Effekt ved full last (kW)',
    isCondensing: 'Kondenserende kjel',
    operatingSchedule: 'Driftsplan',
    startDate: 'Start (dag/måned)',
    endDate: 'Slutt (dag/måned)',
    startOfDay: 'Starttime',
    endOfDay: 'Slutttime',
    seasonalMeanTemp: 'Sesongmiddeltemperatur (°C)',

    // Solar thermal fields
    solarType: 'Soltype',
    vacuumTube: 'Vakuumrør',
    flatPlate: 'Flatplate',
    tilt: 'Helning (°)',
    area: 'Totalt areal (m²)',
    collectorArea: 'Samleareal (m²)',
    pipeLength: 'Rørlengde (m)',
    pipeUValue: 'Rør U-verdi (W/mK)',
    collectorSpecs: 'Kollektorspesifikasjoner',
    efficiencyNormal: 'Virkningsgrad η₀',
    heatLossLinear: 'Varmetap a₁ (W/m²K)',
    heatLossSecond: 'Varmetap a₂ (W/m²K²)',
    opticalEfficiency: 'Optisk virkningsgrad',
    heatLossCoeff: 'Varmetapskoeffisient',
    shadingWinter: 'Skygefaktor vinter',
    shadingSummer: 'Skygefaktor sommer',
    adjustmentFactor: 'Justeringsfaktor',
    tankSpiralPlacementFactor: 'Plasseringsfaktor for tankspiral',
    temperatureColdWater: 'Temperatur på kaldtvann (°C)',
    temperatureInCollectionTank: 'Temperatur i akkumulatortank (°C)',
    percentageOfCollectorLoopOutside: 'Andel av kollektorkrets utendørs (%)',
    snowCoverageMonths: 'Snødekkede måneder',
    selectMonths: 'Velg måneder...',
    insulationFactorForCollectionLoop: 'Isolasjonsfaktor for kollektorkrets',
    selectInsulationFactorForCollectionLoop:
      'Velg isolasjonsfaktor for kollektor...',

    // District heating tables O.1, O.2, O.3
    heatExchangerInsulation: 'Varmeveksler-isolasjon',
    selectHeatExchangerInsulation: 'Velg isolasjon...',
    outletTemperatureRange: 'Utløpstemperaturområde',
    selectOutletTempRange: 'Velg område...',
    outletTempLow: '≤ 50 °C',
    outletTempMedium: '50–70 °C',
    outletTempHigh: '≥ 70 °C',
    bdhCoefficient: 'Varmevekslertap',
    bdhValue: 'Tapskoeffisient',
    supplyTemperatureRange: 'Tilførselstemperaturområde',
    selectSupplyTempRange: 'Velg område...',
    supplyTempHigh: '≥ 150 °C',
    supplyTempMedium: '105–150 °C',
    supplyTempLow: '≤ 105 °C',
    ddhCoefficient: 'Distribusjonsvarmetap',
    ddhValue: 'Tapskoeffisient',
    coolingHeatExchangerInsulation: 'Kjøleveksler-isolasjon',
    selectCoolingHxInsulation: 'Velg isolasjon...',
    coolingHeatExchangerUValue: 'Kjøleveksler',
    coolingHxUValue: 'U-verdi (W/m²K)',

    // CHP tables Q.1, Q.2
    isCHP: 'Kraftvarmeverk (CHP)',
    chpSettings: 'CHP-innstillinger',
    chpFuelType: 'CHP brenseltype',
    selectChpFuelType: 'Velg brenseltype...',
    chpSolidFuel: 'Fast brensel',
    chpLiquidFuel: 'Flytende brensel',
    chpGas: 'Gass',
    chpPerformanceLevel: 'Ytelsesnivå',
    selectChpPerformance: 'Velg ytelse...',
    chpThermalEfficiency: 'Termisk virkningsgrad (%)',
    chpElectricalEfficiency: 'Elektrisk virkningsgrad (%)',
    chpTotalEfficiency: 'Total virkningsgrad (%)',
    chpBoilerType: 'CHP kjeltype',
    selectChpBoilerType: 'Velg kjeltype...',
    chpBiopellets: 'Biopellets',
    chpWoodChips: 'Flis',
    gasOrOilBoiler: 'Gass- eller oljekjel',
    chpC7: 'C\u2087',
    chpC8: 'C\u2088',
    chpN: 'n',

    // Solar thermal pipe insulation table H.2
    pipeInsulationType: 'Rørisolasjonstype',
    selectPipeInsulation: 'Velg isolasjon...',
  },

  // Excess Energy Module
  excessEnergy: {
    eligibleForHarvesting: 'Kvalifisert for energigjenvinning',
    eligibleForHarvestingHelp:
      'Marker denne modulen som kvalifisert for gjenvinning av overskuddsenergi',

    // Duct dimensions
    ductDimensions: 'Kanaldimensjoner',
    ductShape: 'Kanalform',
    diameter: 'Diameter (mm)',
    width: 'Bredde (mm)',
    height: 'Høyde (mm)',
    airspeed: 'Lufthastighet (m/s)',

    // Flow properties
    flowProperties: 'Strømningsegenskaper',
    temperature: 'Avtrekkstemperatur (C)',
    volumeFlow: 'Volumstrøm',
    volumeFlowAir: 'Volumstrøm (m³/h)',
    volumeFlowLiquid: 'Volumstrøm (L/h)',

    // Delete
    deleteModule: 'Slett overskuddsenergimodul',
    confirmDelete: 'Slette denne overskuddsenergimodulen?',
    noModuleFound: 'Ingen overskuddsenergimodul funnet',
  },

  solarPv: {
    // Section headers
    soilingFactors: 'Tilsmussningsfaktorer (\u03C6_soil)',
    panelProperties: 'Panelegenskaper',
    lossesCoefficients: 'Tap og koeffisienter',
    // Panel angle
    panelAngle: 'Panelvinkel',
    tiltRange: 'Helningsområde: {range}\u00B0',
    angleOutOfRange: 'Vinkel utenfor område',
    // Soiling
    selectLocation: 'Velg plassering...',
    usingStandardTable:
      'Bruker {standard} tabell for helningsområde {range}\u00B0',
    // Panel properties
    selectCellType: 'Velg solcelletype...',
    nominalEfficiency: 'Nominell virkningsgrad (0-1)',
    panelAzimuth: 'Panel asimut (0-360°)',
    shadingFactor: 'Skyggefaktor (0-1)',
    // Losses & coefficients
    mountingType: 'Monteringstype',
    selectMountingType: 'Velg monteringstype...',
    windExposure: 'Vindeksponering',
    selectWindExposure: 'Velg vindeksponering...',
    heatLossFactor: 'Varmetapsfaktor (W/m²K)',
    inverterEfficiency: 'Invertervirkningsgrad (0-1)',
    degradationLoss: 'Degraderingstap (0-1)',
    inverterLoss: 'Invertertap (0-1)',
    transmissionProduct: 'Transmisjonsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoeffisient (%/°C)',
    incidentAngleModifier: 'Innfallsvinkelmodifikator (0-1)',
    // Delete
    deleteModule: 'Slett solcellemodul',
    confirmDelete: 'Slette denne solcellemodulen?',
  },

  // Battery edit page
  battery: {
    annualSimOnly:
      'Batterier er foreløpig bare med i årssimuleringer. De er ennå ikke med i beregningen av energimerke.',
    maxCapacity: 'Maks kapasitet (kWh)',
    maxChargePower: 'Maks ladeeffekt (kW)',
    maxDischargePower: 'Maks utladingseffekt (kW)',
    chargeEfficiency: 'Ladevirkningsgrad (0-1)',
    dischargeEfficiency: 'Utladingsvirkningsgrad (0-1)',
    minStateOfCharge: 'Minste ladenivå (0-1)',
    maxStateOfCharge: 'Høyeste ladenivå (0-1)',
    peakShavingThreshold: 'Grense for effekttopper (kW)',
    preChargeStateOfCharge: 'Ladenivå for forhåndslading (0-1)',
    maxCapacityRequired: 'Maks kapasitet større enn 0 er påkrevd',
    maxChargePowerRequired: 'Maks ladeeffekt større enn 0 er påkrevd',
    maxDischargePowerRequired: 'Maks utladingseffekt større enn 0 er påkrevd',
    deleteBattery: 'Slett batteri',
    confirmDelete: 'Slette dette batteriet?',
  },

  // HVAC system type options
  hvacSystemTypes: {
    balanced: 'Balansert',
    exhaust: 'Avtrekk',
    supply: 'Tilluft',
  },

  // HVAC edit page
  hvac: {
    deleteUnit: 'Slett HVAC-enhet',
    confirmDelete: 'Slette denne HVAC-enheten?',
    // List columns
    heatRecoveryShort: 'Varmegjenvinning',
    airVolumeShort: 'Luftmengde',
    // DX Systems
    addDxSystem: 'Legg til DX-system',
    confirmDeleteDxSystem: 'Slette dette DX-systemet?',
    // Heating batteries
    addHeatingBattery: 'Legg til varmebatteri',
    confirmDeleteHeatingBattery: 'Slette dette varmebatteriet?',
    // Cooling batteries
    addCoolingBattery: 'Legg til kjølebatteri',
    confirmDeleteCoolingBattery: 'Slette dette kjølebatteriet?',

    // Section headers
    namePlaceholder: 'Navn på ventilasjonsaggregat',
    dxSystemNamePlaceholder: 'Navn på DX-system',
    batteryNamePlaceholder: 'Navn på batteri',
    flowSfpSettings: 'Luftmengde og SFP-innstillinger',
    temperatureMeasurements: 'Temperaturmålinger',
    dxSystems: 'DX (Direkteekspansjon)',
    heatingBatteries: 'Varmebatterier',
    coolingBatteries: 'Kjølebatterier',
    naturalVentilation: 'Naturlig ventilasjon',

    // SFP fields
    sfpCalculationMethod: 'SFP-beregningsmetode',
    sfpAsFunction: 'Spesifikk vifteeffekt',
    yearBands: {
      pre1985: 'Før 1985',
      '1985to1995': '1985 til 1995',
      '1995to2005': '1995 til 2005',
      '2005to2013': '2005 til 2013',
      '2013to2020': '2013 til 2020',
      from2020: '2020 og nyere',
    },
    suggestions: {
      yearHelp:
        'Året ventilasjonsaggregatet ble installert. Det bestemmer typisk motortype, SFP og varmegjenvinning for perioden.',
      hintLabel: 'Forslag',
      calculatedLabel: 'Beregnet',
      apply: 'Bruk',
      applyAll: 'Bruk ({count}) forslag',
      noSuggestions: 'Ingen forslag',
      applyAllHelp: 'Bruk alle foreslåtte verdier på denne siden.',
    },

    // Flow fields
    fanPower: 'Vifteeffekt',
    coverage: 'Dekning',
    fanPowerIn: 'Vifteeffekt tilluft (kW)',
    fanPowerOut: 'Vifteeffekt avtrekk (kW)',
    // Supply air volume
    supplyAirVolume: 'Tilluft',
    airVolumeOperating: 'Drift (m³/h)',
    airVolumeCapacity: 'Kapasitet (m³/h)',
    airVolumeNonOperating: 'Utenfor drift (m³/h)',
    // Extraction air volume
    extractionAirVolume: 'Avtrekk',
    airVolumeExtractionOperating: 'Drift (m³/h)',
    airVolumeExtractionCapacity: 'Kapasitet (m³/h)',
    airVolumeExtractionNonOperating: 'Utenfor drift (m³/h)',

    // Heat recovery
    heatRecoveryType: 'Varmegjenvinningstype',
    efficiencyHR: 'Virkningsgrad VG (%)',
    frostProtection: 'Frostbeskyttelse',
    frostProtectionTemperature: 'Frostbeskyttelsestemperatur (°C)',

    // Temperature
    measuredSupplyTemp: 'Målt tillufttemp (°C)',
    measuredExhaustTemp: 'Målt avtrekkstemp (°C)',

    // DX System
    dxSystem: 'DX-system',
    dxType: 'Type',

    // Battery fields
    heatingBattery: 'Varmebatteri',
    coolingBattery: 'Kjølebatteri',
    batteryType: 'Type',

    // Priority lists
    heatingPriorityList: 'Varmeprioritet',
    coolingPriorityList: 'Kjøleprioritet',
    priorityListHelp: 'Dra for å endre prioritet i beregninger',
    noPriorityItems: 'Ingen elementer konfigurert',

    // zone linking
    linkedZones: 'Koblede soner',
    noLinkedZones: 'Ingen soner koblet',
    manageZones: 'Administrer soner',
    useZoneMap: 'Bruk sonekart',
    linkZonesTitle: 'Koble termiske soner',
    noZonesAvailable: 'Ingen termiske soner tilgjengelig',
    zonesLinked: 'Soner koblet',
    noZoneWarning:
      'Denne ventilasjonsenheten er ikke koblet til en termisk sone.',
    noZoneListWarning: '{name} er ikke koblet til en termisk sone.',
    sfp100Required: 'SFP @ 100% større enn 0 er påkrevd',
    airVolumeOperatingRequired: 'Tilluft drift større enn 0 er påkrevd',
    airVolumeCapacityRequired: 'Tilluft kapasitet større enn 0 er påkrevd',
    airVolumeExtractionOperatingRequired:
      'Avtrekk drift større enn 0 er påkrevd',
    dxEnergySourceRequired: 'Hvert DX-system trenger en energikilde',
    dxSystemEfficiencyRequired:
      'Hvert DX-system trenger en systemvirkningsgrad større enn 0',
    heatingBatteryPowerRequired:
      'Hvert varmebatteri trenger en effekt større enn 0',
    heatingBatterySystemEfficiencyRequired:
      'Hvert varmebatteri trenger en systemvirkningsgrad større enn 0',
    heatingBatteryEnergySourceRequired:
      'Hvert varmebatteri trenger en energikilde',
    coolingBatteryPowerRequired:
      'Hvert kjølebatteri trenger en effekt større enn 0',
    coolingBatterySystemEfficiencyRequired:
      'Hvert kjølebatteri trenger en systemvirkningsgrad større enn 0',
    coolingBatteryEnergySourceRequired:
      'Hvert kjølebatteri trenger en energikilde',

    supplementaryFactor: 'Tilleggsfaktor',

    // Motor type dropdown options
    motorType: 'Motortype',
    motorTypes: {
      none: 'Ingen',
      belt: 'Reimdrift',
      axial: 'Aksialvifte',
      EC: 'EC-motor',
      AC: 'AC-motor',
      DC: 'DC-motor',
      VSD: 'Frekvensomformer (VSD)',
      other: 'Annet',
    },

    // DX type dropdown options
    dxTypes: {
      cooling: 'Kun kjøling',
      heating: 'Kun oppvarming',
      both: 'Både oppvarming og kjøling',
    },

    // Flow type radio options
    flowTypes: {
      variable: 'Variabel luftmengde',
      constant: 'CAV, konstant luftmengde',
      optimal: 'DCV, behovsstyrt',
    },

    // Battery types
    batteryTypes: {
      water: 'Vann',
      electric: 'Elektrisk',
      heatPump: 'Varmepumpe',
      other: 'Annet',
    },

    // Heat recovery types (keys match NS 3031:2025 Table B.6)
    heatRecoveryTypes: {
      rotaryWheel: 'Roterende gjenvinner',
      crossFlow: 'Kryssstrøms plategjenvinner',
      plateCounterflow: 'Motstrøms plategjenvinner',
      runAroundCoil: 'Væskekoblet batteri',
      heatPipe: 'Varmerør',
      none: 'Ingen',
    },
  },

  // Exterior wall edit page
  exteriorWall: {
    namePlaceholder: 'Veggnavn',
    direction: 'Retning',
    type: 'Veggtype',
    shadingFactor: 'Skygge',
    deleteWall: 'Slett vegg',
    confirmDelete: 'Slette denne veggen?',
    directionRequired: 'Vennligst velg en retning for veggen',
    areaRequired: 'Veggareal større enn 0 er påkrevd',
    uValueRequired: 'U-verdi større enn 0 er påkrevd',
    windowsExceedArea: 'Total vindusareal overstiger veggarealet.',
    doorsExceedArea: 'Total dørareal overstiger veggarealet.',
    gatesExceedArea: 'Total portareal overstiger veggarealet.',
    combinedExceedArea:
      'Samlet areal av vinduer, dører og porter overstiger veggarealet.',
    windowsExceedAreaList: '{name}: total vindusareal overstiger veggarealet.',
    doorsExceedAreaList: '{name}: total dørareal overstiger veggarealet.',
    gatesExceedAreaList: '{name}: total portareal overstiger veggarealet.',
    combinedExceedAreaList:
      '{name}: samlet areal av vinduer, dører og porter overstiger veggarealet.',
    options: {
      custom: 'Egendefinert',
      standard: 'Standard',
      timberFrame36_150: 'Treramme 36mm, 150mm isolasjon',
      timberFrame36_200: 'Treramme 36mm, 200mm isolasjon',
      timberFrame36_250: 'Treramme 36mm, 250mm isolasjon',
      timberFrame48_150: 'Treramme 48mm, 150mm isolasjon',
      timberFrame48_200: 'Treramme 48mm, 200mm isolasjon',
      timberFrame48_250: 'Treramme 48mm, 250mm isolasjon',
      epsBlock310: 'EPS-blokk 310mm (140mm betongkjerne)',
      epsBlock370: 'EPS-blokk 370mm (140mm betongkjerne)',
      epsBlock430: 'EPS-blokk 430mm (140mm betongkjerne)',
      iProfile200: 'I-profil stålramme, 200mm isolasjon',
      iProfile300: 'I-profil stålramme, 300mm isolasjon',
      iProfile400: 'I-profil stålramme, 400mm isolasjon',
      lwaBlock250: 'Lettklinkerblokk (Isoblokk) 250mm',
      lwaBlock300: 'Lettklinkerblokk (Isoblokk) 300mm',
      lwaBlock350: 'Lettklinkerblokk (Isoblokk) 350mm',
      slottedSteel200: 'Slisset stål, 200mm isolasjon',
      slottedSteel250: 'Slisset stål, 250mm isolasjon',
      slottedSteel300: 'Slisset stål, 300mm isolasjon',
      unslottedSteel200: 'Uslisset stål, 200mm isolasjon',
      unslottedSteel250: 'Uslisset stål, 250mm isolasjon',
      unslottedSteel300: 'Uslisset stål, 300mm isolasjon',
    },
  },

  // Building types (NS 3031 categories)
  buildingTypes: {
    label: {
      smallHouse: 'Småhus',
      apartmentBlock: 'Boligblokk',
      kindergarten: 'Barnehage',
      officeBuilding: 'Kontor',
      schoolBuilding: 'Skole',
      universityCollege: 'Universitet/Høgskole',
      hospital: 'Sykehus',
      nursingHome: 'Sykehjem',
      hotelBuilding: 'Hotell',
      sportsBuilding: 'Idrett',
      commercialBuilding: 'Forretning',
      culturalBuilding: 'Kultur',
      lightIndustry: 'Lett industri/Lager',
    },
    description: {
      smallHouse:
        'Enebolig, tomannsbolig, rekkehus, kjedehus eller andre små boliger.',
      apartmentBlock:
        'Boligblokk med to eller flere etasjer, inkludert store rekkehus med flere etasjer.',
      kindergarten:
        'Bygninger beregnet for barnehage eller tidlig barneopplæring.',
      officeBuilding:
        'Enkle kontorer, kontorer med ventilasjon og kjøling, eller utstillings-/kongressbygninger.',
      schoolBuilding:
        'Undervisningslokaler, inkludert skoler med svømmehall eller idrettshall.',
      universityCollege:
        'Universitets- eller høgskolebygninger, laboratoriebygninger eller forskningsanlegg.',
      hospital:
        'Sykehus, sykehushotell eller laboratoriebygninger for medisinsk bruk.',
      nursingHome: 'Sykehjemsbygninger for langtidspleie.',
      hotelBuilding:
        'Hoteller, restaurantbygninger eller andre bygninger for overnatting.',
      sportsBuilding:
        'Idrettshaller, svømmehaller og andre idrettsanlegg med dusj.',
      commercialBuilding:
        'Butikker, varehus med kjøle-/fryserom eller bensinstasjoner.',
      culturalBuilding: 'Kinoer, museer, biblioteker og religiøse bygninger.',
      lightIndustry:
        'Industribygninger, lagerbygninger, fiskeri-/landbruksbygninger, energiforsyningsanlegg eller andre verksteder.',
    },
  },

  buildingSubcategories: {
    1: 'Enebolig',
    2: 'Enebolig med utleiedel',
    3: 'Tomannsbolig horisontalt delt',
    4: 'Tomannsbolig vertikalt delt',
    5: 'Firemannsbolig',
    6: 'Kjedet enebolig',
    7: 'Rekkehus',
    8: 'Fritidsbolig',
    9: 'Annet småhus',
    10: 'Leilighet',
    11: 'Annen bolig',
    12: 'Barnehagebygning',
    13: 'Kontorer, enkle',
    14: 'Kontorer med ventilasjons- og kjøleanlegg',
    15: 'Messe-/kongressbygning',
    16: 'Annen kontorbygning',
    17: 'Undervisningslokaler',
    18: 'Skole med svømmeanlegg',
    19: 'Skole med idrettshall',
    20: 'Undervisningsbygning',
    21: 'Laboratoriebygning',
    22: 'Annen forskningsbygning',
    23: 'Sykehus',
    24: 'Sykehotell',
    25: 'Sykehuslaboratoriebygning',
    26: 'Sykehjemsbygning',
    27: 'Hotellbygning',
    28: 'Bygning for overnatting',
    29: 'Restaurantbygning',
    30: 'Annen hotellbygning',
    31: 'Idrettshall',
    32: 'Idrettshall med dusjanlegg',
    33: 'Idrettshall med svømmeanlegg',
    34: 'Butikk',
    35: 'Butikk med kjølerom',
    36: 'Bensinstasjon',
    37: 'Kulturbygning',
    38: 'Kino',
    39: 'Museum-/biblioteksbygning',
    40: 'Bygning for religiøse aktiviteter',
    41: 'Industribygning',
    42: 'Energiforsyningsbygning',
    43: 'Lagerbygning',
    44: 'Fiskeri-/landbruksbygning',
    45: 'Annen industri',
  },

  thermalZones: {
    schedule: {
      heatingSchedule: 'Oppvarmingsplan',
      coolingSchedule: 'Kjøleplan',
      addHeatingSchedule: 'Legg til varmeplan',
      addCoolingSchedule: 'Legg til kjøleplan',
    },
    yearPeriods: {
      TEK50: 'Før 1969',
      TEK70: '1970 - 1979',
      TEK80: '1980 - 1986',
      TEK87: '1987 - 1996',
      TEK97: '1997 - 2006',
      TEK07: '2007 - 2009',
      TEK10: '2010 - 2016',
      TEK17: '2017 og senere',
    },
    hasFloorToGround: 'Sonen har gulv mot grunn',
    hasRoof: 'Sonen har yttertak',
    isBasement: 'Sonen er en kjeller',
    floor: {
      type: 'Type gulv mot grunn',
      area: 'Gulv mot grunn (m²)',
      options: {
        custom: 'Egendefinert',
        standard: 'Standard',
        tiles: 'Fliser på betong',
        parquetChipBoard: 'Parkett på sponplate',
        carpetConcrete: 'Teppe på betong',
      },
    },
    roof: {
      type: 'Taktype',
      optionsTitle: 'Takkonstruksjon',
      angle: 'Takvinkel',
      hasWindows: 'Yttertaket har vinduer',
      areaRequired: 'Takareal større enn 0 er påkrevd',
      windowArea: 'Vindusareal (m²)',
      glassType: 'Glasstype',
      pitchTypes: {
        flat: 'Flatt tak',
        lowSlope: 'Lav helling',
        gentlePitch: 'Svak helling',
        standardPitch: 'Standard helling',
        steepPitch: 'Bratt helling',
        verySteepPitch: 'Veldig bratt helling',
      },
      options: {
        custom: 'Egendefinert',
        standard: 'Standard',
        compactConcrete200: 'Kompakttak, betong, 200mm isolasjon',
        compactConcrete300: 'Kompakttak, betong, 300mm isolasjon',
        compactConcrete400: 'Kompakttak, betong, 400mm isolasjon',
        compactSteel200: 'Kompakttak, stål, 200mm isolasjon',
        compactSteel300: 'Kompakttak, stål, 300mm isolasjon',
        compactSteel400: 'Kompakttak, stål, 400mm isolasjon',
        pitched48mm200: 'Skråtak, 48mm sperrer, 200mm isolasjon',
        pitched48mm300: 'Skråtak, 48mm sperrer, 300mm isolasjon',
        pitched48mm400: 'Skråtak, 48mm sperrer, 400mm isolasjon',
        pitchedIBeam200: 'Skråtak, I-bjelker, 200mm isolasjon',
        pitchedIBeam300: 'Skråtak, I-bjelker, 300mm isolasjon',
        pitchedIBeam450: 'Skråtak, I-bjelker, 450mm isolasjon',
        coldAttic200: 'Kaldt loft, 200mm isolasjon',
        coldAttic300: 'Kaldt loft, 300mm isolasjon',
        coldAttic450: 'Kaldt loft, 450mm isolasjon',
      },
    },
    basement: {
      dimensions: 'Dimensjoner',
      area: 'Gulvareal mot grunn (m²)',
      wallPerimeter: 'Eksponert veggomkrets (m)',
      fillHeight: 'Dybde under terreng (m)',
      wallThickness: 'Veggtykkelse (m)',
      wallConstruction: 'Kjellervegg',
      wallConstructionType: 'Veggtype',
      wallUValue: 'U-verdi vegg (W/m²K)',
      floorConstruction: 'Kjellergulv',
      floorConstructionType: 'Gulvtype',
      floorUValue: 'U-verdi gulv (W/m²K)',
      intro: 'Husk å redusere gulv mot grunn i sonen over med kjellerarealet.',
      floorConstructionOptions: {
        none: 'Ingen',
        standard: 'Standard',
        concrete100: 'Betong på grunn med 100 mm isolasjon',
        concrete150: 'Betong på grunn med 150 mm isolasjon',
        concrete200: 'Betong på grunn med 200 mm isolasjon',
        concrete250: 'Betong på grunn med 250 mm isolasjon',
        concrete300: 'Betong på grunn med 300 mm isolasjon',
        concrete350: 'Betong på grunn med 350 mm isolasjon',
        concrete400: 'Betong på grunn med 400 mm isolasjon',
        wood200: 'Trebjelkelag med 200 mm isolasjon',
        wood250: 'Trebjelkelag med 250 mm isolasjon',
        wood300: 'Trebjelkelag med 300 mm isolasjon',
      },
    },
    groundConditions: {
      type: 'Grunntype',
      thermalConductivity: 'Varmekonduktivitet λ (W/(m·K))',
      heatCapacity: 'Varmekapasitet Cv (Wh/(m³·K))',
      penetrationDepth: 'Periodisk nedtrengningsdybde δ (m)',
      options: {
        clay: 'Leire/silt',
        sand: 'Sand/grus',
        rock: 'Fjell',
      },
    },
    thermalMass: {
      buildingHeatCapacity: 'Sonens varmekapasitet',
      heatCapacityCategory: 'Varmekapasitetskategori',
      normalizedHeatCapacity: 'Normalisert varmekapasitet (Wh/m²K)',
      interiorWalls: 'Innervegger',
      cladding: 'Kledning',
      heatCapacity: 'Varmekapasitet (Wh/m²K)',
      furniture: 'Møbler',
      furnitureGrade: 'Møbelgrad',
      massFactor: 'Massefaktor (Wh/m²K)',
      heatCapacityCategoryRequired: 'Vennligst velg en varmekapasitetskategori',
      claddingRequired: 'Vennligst velg en kledning',
      furnitureGradeRequired: 'Vennligst velg en møbelgrad',
      labelFirstOption: 'Meget lett sone',
      labelSecondOption: 'Lett sone',
      labelThirdOption: 'Middels tung sone',
      labelFourthOption: 'Tung sone',
      labelFifthOption: 'Meget tung sone',
      shortDescriptionFirstOption:
        'Lett bjelkelag, tynt gulvbelegg, lette vegger',
      shortDescriptionSecondOption:
        'Akustisk himling, teppe over betong, lette vegger',
      shortDescriptionThirdOption:
        'Lite eksponert betong (20%), parkett over betong',
      shortDescriptionFourthOption: 'Hovedsakelig eksponert betong (70%)',
      shortDescriptionFifthOption: 'Eksponert betong i himling, vegger og gulv',
      claddingOptions: {
        custom: 'Tilpasset',
        standard: 'Standard',
        concrete100: '100 mm (eller mer) betong',
        concrete80: '80 mm betong',
        aeratedConcrete: 'Gassbetong',
        gypsum13: 'Gips 13 mm',
        lightBrick: 'Lett tegl',
        lwa: 'Lettklinker',
        solidWood40: 'Massivtre (tykkelse over 40 mm)',
        woodPanel15: 'Trepanel 15 mm',
        heavyBrick: 'Tung (kompakt) tegl',
      },
      furnitureOptions: {
        none: 'Ingen',
        standard: 'Standard',
        light: 'Lett',
        medium: 'Middels',
        heavy: 'Tung',
      },
    },
    airLeakage: {
      tekStandard: 'TEK-standard',
      n50: 'Lekkasjetall n50 (h⁻¹)',
      tekOptions: {
        TEK50: 'Byggforskrift 1950–1969',
        TEK70: 'Byggforskrift 1970–1979',
        TEK80: 'Byggforskrift 1980–1986',
        TEK87: 'TEK 87 (1987-1996)',
        TEK97: 'TEK 97 (1997-2006)',
        TEK07: 'TEK 07 (2007-2009)',
        TEK10: 'TEK 10 (2010-2016)',
        TEK17: 'TEK 17 (2017+)',
      },
    },
    windows: {
      deleteWindow: 'Slett vindu',
      confirmDelete: 'Slette dette vinduet?',
      gValue: 'g-verdi',
      frameFraction: 'Karmfaktor',
      shadingFactor: 'Skyggefaktor (0-1)',
      externalBlinds: 'Utvendige persienner (gt)',
      externalBlindsGt: 'Utvendige persienner gt',
      externalScreen: 'Utvendig duk (gt)',
      externalScreenGt: 'Utvendig duk gt',
      internalShading: 'Innvendig solskjerming (gt)',
      internalShadingGt: 'Innvendig solskjerming gt',
      windowTypes: {
        none: 'Ingen',
        custom: 'Egendefinert',
        singleGlass: 'Enkeltglass',
        twoLayerGlass: 'To koblede glass',
        twoLayerEnergyGlass: 'Tolags energiglass',
        twoLayerSolarReflective: 'Tolags solreflekterende glass',
        threeLayerEnergyGlass: 'Trelags energiglass',
      },
    },
    doors: {
      deleteDoor: 'Slett dør',
      confirmDelete: 'Slette denne døren?',
      type: 'Dørtype',
      doorTypes: {
        custom: 'Egendefinert',
        standard: 'Standard',
        insulated: 'Isolert',
        normal: 'Normal',
        wellInsulated: 'Godt isolert',
        uninsulated: 'Uisolert',
      },
    },
    gates: {
      deleteGate: 'Slett port',
      confirmDelete: 'Slette denne porten?',
      type: 'Porttype',
      gateTypes: {
        custom: 'Egendefinert',
        standard: 'Standard',
        insulated: 'Isolert',
        sectional: 'Seksjonsport',
        roller: 'Rulleport',
        wellInsulated: 'Godt isolert',
      },
    },
    internalLoads: {
      internalLoadsNotice:
        'Disse verdiene brukes ikke ved energimerking. Kun tilstedeværelseskontroll for belysning tas med.',
      hotWater: 'Varmtvann',
      equipment: 'Teknisk utstyr',
      occupancy: 'Personer',
      weekday: 'Hverdag (260 dager)',
      weekend: 'Helg (105 dager)',
      resetToStandards: 'Tilbakestill til',
      hourlyProfile: 'Timeprofil',
      editHourlyValues: 'Rediger timeverdier',
      peak: 'Topp',
      avg: 'Snitt',
      daily: 'Daglig',
      annual: 'Årlig',
      appliances: 'Hvitevarer',
      appliancesDescription:
        'Reduser elektrisk energibehov ved å koble hvitevarer til varmtvann.',
      dishwasherLabel: 'Oppvaskmaskin (varmtvann)',
      washingMachineLabel: 'Vaskemaskin (varmtvann)',
      tumbleDryerLabel: 'Tørketrommel (varmtvann)',
      applianceShareLabel: 'Termisk andel [%]',
      heatGainShareLabel: 'Varmetilskudd til sone [1-100%]',
      lampTypes: 'Lampetyper',
      lampType: 'Lampetype',
      selectLampType: 'Velg lampetype',
      ballast: 'Forkoblingsutstyr',
      electronic: 'Elektronisk',
      electromechanical: 'Elektromekanisk',
      sharePercent: 'Andel (%)',
      efficiencyFactorFL: 'Effektivitetsfaktor (FL)',
      lampTypeNames: {
        ledNew: 'LED fra 2016 og nyere',
        ledOld: 'LED fra 2010–2015',
        fluorescentT5: 'Lysrør T5',
        fluorescentT8: 'Lysrør T8',
        metalHalide: 'Metallhalogenlampe',
        highPressureSodium: 'Høytrykksnatriumlampe',
        compactFluorescent: 'Kompaktlysrør',
        halogen: 'Halogenlampe',
        incandescent: 'Glødelampe',
      },
      addLampType: 'Legg til lampetype',
      deleteLampType: 'Slette denne lampetypen?',
    },
    heatingEmissionSystem: 'Varmeavgivelsessystem',
    heatingEmissionSystems: {
      radiator_thermostat_80_60:
        'Radiator/konvektor med termostatventil eller lokal romregulator',
      radiator_thermostat_60_40:
        'Radiator/konvektor med termostatventil eller lokal romregulator',
      radiator_thermostat_40_35:
        'Radiator/konvektor med termostatventil eller lokal romregulator',
      radiator_sd_80_60: 'Radiator/konvektor tilkoblet SD',
      radiator_sd_60_40: 'Radiator/konvektor tilkoblet SD',
      radiator_sd_40_35: 'Radiator/konvektor tilkoblet SD',
      fan_coil_heat_pump:
        'Viftekonvektor / varmepumpe innedel / aktiv kjølebaffel / oppvarming via ventilasjonsluft',
      floor_heating_thermostat:
        'Gulvvarme med termostatventil eller lokal romregulator',
      floor_heating_sd: 'Gulvvarme tilkoblet SD',
      panel_heater_pre_2010: 'Panelovn – før 2010',
      panel_heater_post_2010: 'Panelovn – etter 2010',
    },
    coolingEmissionSystem: 'Kjøleavgivelsessystem',
    coolingEmissionSystems: {
      chilled_beam_thermostat:
        'Passiv kjølebaffel med termostatventil eller lokal romregulator',
      chilled_beam_sd: 'Passiv kjølebaffel tilkoblet SD',
      fan_coil_cool_pump:
        'Kombibaffel / viftekonvektor / fancoil med lokal romregulator',
      fan_coil_cool_pump_sd:
        'Kombibaffel / viftekonvektor / fancoil tilkoblet SD',
      floor_cooling_thermostat: 'Gulvsvale/-kjøling med lokal romregulator',
      floor_cooling_sd: 'Gulvsvale/-kjøling tilkoblet SD',
      chilled_ceiling_thermostat: 'Kjøletak med lokal romregulator',
      chilled_ceiling_sd: 'Kjøletak tilkoblet SD',
    },
    effectiveSetpoint: 'Effektivt settpunkt',
  },

  // Thermal Zone Links
  thermalZoneLinks: {
    linkZones: 'Koble soner',
    resetLayout: 'Tilbakestill posisjoner',
    resetLayoutConfirm:
      'Tilbakestille kartoppsettet? Alle soner går tilbake til foreslått plassering.',
    confirmLink: 'Bekreft kobling',
    linkDialogTitle: 'Koble termiske soner',
    linkingZones: 'Kobler soner',
    sourceZone: 'Kildesone',
    targetZones: 'Målsoner',
    areaUnit: 'm²',
    uValueUnit: 'W/m²K',
    selectSourceFirst: 'Velg kildesone først, deretter målsoner',
    minTwoZones: 'Velg minst 2 soner å koble',
    linkSuccess: 'Soner koblet',
    externalZone: 'Ekstern sone',
    zoneConnections: 'Sonekobling',
    addConnection: 'Legg til kobling',
    noConnections: 'Ingen sonekoblinger',
    connectionDeleted: 'Kobling fjernet',
    deleteConnectionError: 'Kunne ikke slette koblingen',
    connectionAdded: 'Kobling lagt til',
    connectionUpdated: 'Kobling oppdatert',
    editConnection: 'Rediger kobling',
    deleteConnection: 'Slett kobling',
    confirmDeleteConnection: 'Fjern sonekobling?',
    connectToExisting: 'Eksisterende sone',
    connectToExternal: 'Ekstern sone',
    chooseConnectionType: 'Koble til',
    zoneMap: 'Sonekart',
    zoneMapEmpty: 'Ingen sonekoblinger',
    notLinked: 'Ikke koblet',
    autoLinked: 'Automatisk koblet',
    linkModeHintSource: 'Klikk på kildesonen',
    linkModeHintTarget: 'Klikk på målsonen, eller velg ekstern sone',
    deleteModeHint: 'Klikk på sonen du vil slette koblinger fra',
    ventilation: 'Ventilasjon',
    zoneMapSubtitle: 'Flytt sonene for å tilpasse oppsettet.',
    noVentilationUnits: 'Ingen ventilasjonsenheter tilgjengelig',
    noHeatingCoolingModules: 'Ingen oppvarming eller kjøling tilgjengelig',
    linkAny: 'Koble',
    linkModeHintSourceAny: 'Klikk på kilden',
    linkModeHintTargetAny: 'Klikk på målet, eller velg ekstern sone',
    deleteModeHintAny:
      'Klikk på sonen eller ventilasjonsenheten du vil slette koblinger fra',
  },

  analytics: {
    energyToggle: 'Energi',
    analyticsToggle: 'Analyse',
    compareToggle: 'Sammenlign',
    runSimulation: 'Kjør simulering',
    runCoverNeedSimulation: 'Kjør minstekravsimulering',
    coverNeedTooltip:
      'Kjører simuleringen med fiktive systemer etter minstekrav, slik at hele energibehovet dekkes der systemer mangler eller ikke strekker til',
    coverNeedAssumptionsTitle: 'Antakelser i minstekravsimuleringen',
    simulating: 'Simulerer...',
    exportToExcel: 'Eksporter til Excel',
    sendToEnova: 'Send til Enova',
    resendToEnova: 'Send til Enova på nytt',
    downloadEnovaPdf: 'Last ned Enova PDF',
    sentToEnovaSuccess: 'Sendt til Enova',
    sendToEnovaError: 'Kunne ikke sende til Enova',
    simulationStartedRefresh:
      'Beregningene er startet, oppdater eller gå tilbake til denne siden etter 10 sekunder',
    simulationStartError: 'Kunne ikke starte simuleringen',
    runRequiresZoneSelection: 'Velg minst én sone før du kjører simuleringen.',
    solarNotIncludedInZones:
      'Solproduksjon beregnes på bygningsnivå og er ikke inkludert i resultater og sammenligninger per sone.',
    resultsCalculatedAt: 'Beregnet {datetime}',
    resultsCalculatedWithStandard: 'Beregnet {datetime} etter {standard}',
    enovaMissingTiltakDescription:
      'Fyll inn beskrivelsen under Tiltak i Energimerke.',
    enovaNoIncludedActions:
      'Aktiver minst ett tiltak som skal inkluderes, eller fjern haken for Inkluder tiltak og fyll inn en beskrivelse.',
    enovaMissingActionDescriptions: 'Fyll inn beskrivelser for: {actions}',
    enovaMissingCredentials:
      'Fyll inn {fields} i brukerprofilen din før du sender til Enova.',
    enovaNoMatrikkelSelected:
      'Velg minst én bruksenhet i Matrikkeldata-seksjonen før du sender til Enova.',
    enovaZonesNotSimulated:
      'Kjør energimerkesimuleringen for de valgte sonene før du sender til Enova.',
    enovaNonResidentialMultipleUnits:
      'Kun én bruksenhet kan velges for ikke-bolig-seksjoner.',
    confirmSendToEnovaMessage: 'Er du sikker på at du vil sende til Enova?',
    enovaSendWithMessagesWarning:
      'Simuleringen har {count} meldinger. Sjekk dem før du sender til Enova.',
    simulationProgress: 'Kjører bygningsenergisimulering...',
    simulationMessages: 'Simuleringsmeldinger',
    energyCalcWithStandard: 'Energiberegninger etter {standard}-standarden.',
    energyCalc: 'Energiberegninger',
    noResults:
      'Ingen simuleringsresultater tilgjengelig. Kjør en simulering for å se energidata.',
    analyticsPlaceholder: 'Analysediagrammer vil vises her.',
    // Chart titles & descriptions
    monthlyEnergyBudget: 'Månedlig energibudsjett (behov)',
    deliveredEnergyTitle: 'Leverte energikilder',
    deliveredEnergyDesc:
      'Total levert energi representerer alle energikilder levert til bygningen.',
    energyComparisonTitle: 'Energisammenligning (Netto / Tap / Brutto)',
    energyComparisonDesc:
      'Sammenligner netto energibehov, distribusjon og akkumuleringstap, og brutto energi for hver kategori. Brutto = Netto + Tap.',
    // Chart labels
    showTemperature: 'Vis temperaturlinje',
    energySourcesChartLabel: 'Energikilder',
    totalDeliveredEnergy: 'Total levert energi',
    visible: 'Synlig',
    noData: 'Ingen data',
    nettEnergy: 'Netto energi',
    grossEnergy: 'Brutto energi',
    distributionLossLabel: 'Distribusjon og akkumuleringstap',
    noMonthlyData:
      'Månedlige data er ikke tilgjengelig for denne simuleringen.',
    monthlyChartHelp:
      'Hver stablet søyle representerer det månedlige netto energibehovet fordelt på kategori. Oppvarmingskategorier vises i varme farger, kjøling i blåtoner, og elektriske laster i grønn/gul/grå.',
    netEnergyDemand: 'Netto energibehov',
    distributionLosses: 'Distribusjon og akkumuleringstap',
    grossEnergyDemand: 'Brutto energibehov',
    energySourcesTitle: 'Energikilder (Tilført energi)',
    deliveredExportedEnergyTitle: 'Levert og eksportert energi',
    climaCorrectedEnergyTitle: 'Klimakorrigert levert og eksportert energi',
    netEnergyTitle: 'Netto energi (Netto energibehov)',
    distributionLossTitle:
      'Distribusjonstap (Distribusjon og akkumuleringstap)',
    grossEnergyTitle: 'Brutto energi (Brutto energibehov)',
    category: 'Kategori',
    value: 'Verdi',
    unit: 'Enhet',
    co2: 'CO₂ kg',
    energyType: 'Energitype',
    electricityCategory: '1. Elektrisitet',
    fossilCategory: '2-3. Fossilt brensel',
    renewableCategory: '4. Fornybar oppvarming',
    districtCategory: '5. Fjernenergi',
    otherCategory: '6-8. Andre kilder',
    totalCategory: 'Totalt',
    elSpecific: 'El. spesifikke poster',
    elHeating: 'El. til romoppvarming',
    elCooling: 'El. til kjølesystem',
    elDHW: 'El. til varmtvann',
    elProducedUsed: 'El. produksjon til eget bruk',
    elProducedExported: 'El. produksjon eksportert',
    // Energy source items
    oil: 'Olje',
    gas: 'Gass',
    solidFuel: 'Fast brensel',
    solidBiofuel: 'Fast biobrensel',
    liquidBiofuel: 'Flytende biobrensel',
    gaseousBiofuel: 'Gassformig biobrensel',
    districtHeating: 'Fjernvarme',
    districtCooling: 'Fjernkjøling',
    other: 'Annet',
    sumDelivered: 'Totalt',
    spaceHeating: 'Romoppvarming',
    ventilationHeating: 'Ventilasjonsvarme',
    hotWater: 'Varmtvann',
    spaceCooling: 'Romkjøling',
    ventilationCooling: 'Ventilasjonskjøling',
    fans: 'Vifter',
    pumps: 'Pumper',
    lighting: 'Belysning',
    technicalEquipment: 'Teknisk utstyr',
    total: 'Totalt',
    // Heat loss
    heatLossTitle: 'Varmetap',
    heatLossDesc:
      'Fordeling av bygningens varmetap per komponent. Verdier i W/m²K.',
    hlWalls: 'Vegger',
    hlRoof: 'Yttertak',
    hlFloor: 'Gulv mot grunn',
    hlWindows: 'Vinduer',
    hlDoors: 'Dører',
    hlThermalBridge: 'Kuldebroer',
    hlInfiltration: 'Infiltrasjon',
    hlVentilation: 'Ventilasjon',
    hlTotal: 'Totalt',
    // Varmetapsbudsjett (tabell 3 NS 3031:2025)
    hlBudgetTitle: 'Varmetapsbudsjett',
    hlBudgetCategory: 'Varmetapspost',
    hlBudgetValue: 'Varmetapstall',
    hlWindowsDoors: 'Vinduer og dører',
    hlTransmissionSum: 'Varmetapstall, transmisjon, sum 1–5',
    hlClimateScreenSum: 'Varmetapstall, klimaskjerm, sum 1–6',
    hlTotalSum: 'Varmetapstall, totalt, sum 1–7',
    // Primærenergi
    peDeliveredEnergy: 'Levert energi (elektrisitet)',
    peDeliveredFuel: 'Levert brensel',
    peDistrictHeating: 'Fjernvarme',
    peDistrictCooling: 'Fjernkjøling',
    peOtherDelivered: 'Annen levert energi',
    peElExport: 'El. produksjon for eksport',
    energyLabelTitle: 'Energimerke',
    supplementaryEnergyTitle: 'Supplerende energi',
    primaryEnergyFactorsTitle: 'Primærenergifaktorer',
    carCharging: 'Billading',
    otherEnergyNeeded: 'Annet energibehov',
    energyNeedForOtherBuildings: 'Energibehov til andre bygg',
    peFossilOil: 'Fossil olje',
    peFossilGas: 'Fossil gass',
    peFossilSolid: 'Fossilt fast brensel',
    peBioOil: 'Bioolje',
    peBioGas: 'Biogass',
    peBioSolid: 'Fast biobrensel',
    ventilationSpecsTitle: 'Ventilasjon og viftespesifikasjoner',
    specificFanPower: 'Spesifikk vifteeffekt (SFP)',
    specificAirFlowIn: 'Spesifikk tilluftmengde i driftstid',
    specificAirFlowOut: 'Spesifikk tilluftmengde utenfor driftstid',
    specificExhaustAirFlowIn: 'Spesifikk avtrekkmengde i driftstid',
    specificExhaustAirFlowOut: 'Spesifikk avtrekkmengde utenfor driftstid',
    hcsHeatingTitle: 'Varmesystemer',
    hcsCoolingTitle: 'Kjølesystemer',
    hcsType: 'Type',
    hcsHeatingFactor: 'Virkningsgrad Varmefaktor',
    hcsCoolingFactor: 'Virkningsgrad Kjølefaktor',
    hcsEnergyCoverage: 'Energidekningsgrad',
    hcsInndata: 'Inndata',
    hcsInstalledHeatingEffect:
      'Spesifikk installert effekt for romoppvarming og ventilasjonsvarme',
    hcsInstalledCoolingEffect:
      'Spesifikk installert effekt for romkjøling og ventilasjonskjøling',
    hcsSetpointInOperation: 'Ekvivalent settpunkttemperatur i drift',
    hcsSetpointOutOfOperation: 'Ekvivalent settpunkttemperatur utenfor drift',
    wpeTitle: 'Klimakorrigert vektet levert energi',
    wpeColSource: 'Energikilde',
    wpeColDelivered: 'Klimakorrigert levert- og eksportert energi',
    wpeColFactor: 'Vektingsfaktor',
    wpeColWeighted: 'Klimakorrigert vektet levert energi',
    wpeTotal: 'Totalt, sum 1-6',
    wpeElectricity: 'Levert elektrisitet',
    wpeSolidBio: 'Levert fast biobrensel',
    wpeLiquidBio: 'Levert flytende biobrensel',
    wpeGasBio: 'Levert biobrensel i gassform',
    wpeSolidFossil: 'Levert fast fossilt brensel',
    wpeLiquidFossil: 'Levert flytende fossilt brensel',
    wpeGasFossil: 'Levert fossilt brensel i gassform',
    wpeDistrictHeating: 'Levert fjernvarme',
    wpeDistrictCooling: 'Levert fjernkjøling',
    wpeOther: 'Andre leverte energibærere',
    wpeElExport: 'El-produksjon til eksport (til fradrag)',
    ekBasisHeader: 'Grunnlag for energikarakter',
    ekValueHeader: 'Verdi',
    ekSpecificWeighted: 'Spesifikk klimakorrigert vektet levert energi',
    meTitle: 'Målt energibruk (kWh/år)',
    meColSource: 'Energibærer',
    meColYearGroup: 'År',
    meColAverage: 'Gjennomsnitt',
    meTotalDelivered: 'Totalt levert energi',
    meTotalNetDelivered: 'Totalt netto levert energi (fratrukket ev. eksport)',
    icTitle: 'Innetemperatur',
    icSubtitle: 'Månedlig gjennomsnitt basert på timesverdier',
    icZoneLabel: 'Sone',
    icSingleZoneLabel: 'Innetemperatur',
    dhcLocalHeatingElectricity: 'Lokal varme, elektrisitet',
    dhcLocalHeatingFossilOil: 'Lokal varme, fossil olje',
    dhcLocalHeatingFossilGas: 'Lokal varme, fossil gass',
    dhcLocalHeatingFossilSolid: 'Lokal varme, fossilt fast brensel',
    dhcLocalHeatingBioOil: 'Lokal varme, bioolje',
    dhcLocalHeatingBioGas: 'Lokal varme, biogass',
    dhcLocalHeatingBioSolid: 'Lokal varme, fast biobrensel',
    dhcLocalDistrictHeating: 'Lokal fjernvarme',
    dhcLocalHeatPump: 'Lokal varmepumpe',
    dhcLocalHeatingOther: 'Lokal varme, andre kilder',
    dhcCentralHeatPump: 'Sentral varmepumpe',
    dhcCentralHeatingElectricity: 'Sentral varme, elektrisitet',
    dhcCentralHeatingFossilOil: 'Sentral varme, fossil olje',
    dhcCentralHeatingFossilGas: 'Sentral varme, fossil gass',
    dhcCentralHeatingFossilSolid: 'Sentral varme, fossilt fast brensel',
    dhcCentralHeatingBioOil: 'Sentral varme, bioolje',
    dhcCentralHeatingBioGas: 'Sentral varme, biogass',
    dhcCentralHeatingBioSolid: 'Sentral varme, fast biobrensel',
    dhcCentralDistrictHeating: 'Sentral fjernvarme',
    dhcCentralHeatingOther: 'Sentral varme, andre kilder',
    dhcCentralSolarThermal: 'Sentral solvarme',
    dhcCentralCogeneration: 'Sentral kraftvarme',
    dhcLocalCooling: 'Lokal kjøling',
    dhcCentralCoolingAirWater: 'Sentral kjøling, luft/vann',
    dhcCentralCoolingLiquidWater: 'Sentral kjøling, væske/vann',
    dhcCentralFreeCooling: 'Sentral frikjøling',
    dhcCentralDistrictCooling: 'Sentral fjernkjøling',
    // Internlaster
    internalLoadsTitle: 'Internlaster',
    internalLoadEnergyTitle: 'Internlaster - Energibehov',
    internalLoadHeatTitle: 'Internlaster - Varmetilskudd',
    ilLighting: 'Belysning',
    ilEquipment: 'Teknisk utstyr',
    ilHotWater: 'Varmtvann',
    ilPeople: 'Personer',
    internalLoadsChartTitle: 'Internlaster (Energibehov vs Varmetilskudd)',
    internalLoadsChartDesc:
      'Sammenligner energibehov og varmetilskudd fra interne lastkilder.',
    ilEnergyNeed: 'Energibehov',
    ilSpecificEnergyNeed: 'Spesifikt energibehov',
    ilSpecificHeatGain: 'Spesifikt varmetilskudd',
    ilHeatGain: 'Varmetilskudd',
    // Month names
    month: 'Måned',
    monthJan: 'Jan',
    monthFeb: 'Feb',
    monthMar: 'Mar',
    monthApr: 'Apr',
    monthMay: 'Mai',
    monthJun: 'Jun',
    monthJul: 'Jul',
    monthAug: 'Aug',
    monthSep: 'Sep',
    monthOct: 'Okt',
    monthNov: 'Nov',
    monthDec: 'Des',
    // Information table (general + climate)
    bdTitle: 'Informasjon',
    bdParameter: 'Generelt',
    bdInputValue: 'Inngangsverdi',
    bdBuildingCategory: 'Bygningskategori',
    bdBuildingType: 'Bygningstype',
    bdYearOfConstruction: 'Byggeår',
    bdTekStandard: 'TEK standard',
    bdCalculationDate: 'Beregningsdato',
    bdClimateInformation: 'Klima',
    bdClimateStationSource: 'Klimastasjon kilde',
    bdClimateStation: 'Klimastasjon',
    bdClimateCorrectionFactor: 'Klimakorreksjonsfaktor',
    bdYearlyAverageTemperature: 'Årsmiddeltemperatur',
    efTitle: 'Energiflyt',
    efColCategory: 'Energipost',
    efColNet: 'Netto energibehov',
    efColDist: 'Distribusjons og akkumuleringstap',
    efColGross: 'Brutto energibehov',
    efColSpf: 'SPF',
    efColDelivered: 'Tilført energi',
    efTotal: 'Totalt',
    // Vektingsfaktorer energibærere (T.2 NS 3031:2025)
    wfTitle: 'Vektingsfaktorer energibærere',
    wfType: 'Type',
    wfWeightFactor: 'Vektingsfaktor',
    wfClimateFactor: 'Klimagassfaktor (CO²-ekvivalent)',
    wfEnergyPrice: 'Energipris',
    wfOtherWeighting: 'Annen vekting',
    wfElectricity: 'Levert elektrisitet',
    wfBioSolid: 'Fast biobrensel',
    wfBioLiquid: 'Flytende biobrensel',
    wfBioGas: 'Biobrensel i gassform',
    wfFossilSolid: 'Fast fossilt brensel',
    wfFossilLiquid: 'Flytende fossilt brensel',
    wfFossilGas: 'Fossilt brensel i gassform',
    wfDistrictHeating: 'Fjernvarme',
    wfDistrictCooling: 'Fjernkjøling',
    wfOther: 'Annen',
    wfExportedElectricity: 'Eksportert elektrisitet',
    // Distribusjonssystemer
    dsTitle: 'Distribusjonssystemer',
    dsCategory: 'Størrelser',
    dsValue: 'Inndata',
    dsRoomHeating: 'Romoppvarming',
    dsVentilationHeating: 'Ventilasjonsvarme',
    dsDhwCirculation: 'Sirkulasjon varmtvann',
    dsRoomCooling: 'Romkjøling',
    dsVentilationCooling: 'Ventilasjonskjøling',
    dsPipeLength: 'Løpemeter distribusjonsrør per BRA',
    dsPumpPower: 'Spesifikk pumpeeffekt',
    // Elektrisitet (tabell T.2 NS 3031:2025)
    elTitle: 'Elektrisitet',
    elCategory: 'Størrelser',
    elValue: 'Inndata',
    elSolarEfficiency: 'Årsvirkningsgrad for solkraftsystem',
    elSolarInstalled: 'Installert effekt på solkraftanlegg (Ppeak)',
    elSolarCoverage: 'Energidekning av el-spesifikt energibehov fra solkraft',
    elWindCoverage: 'Energidekning av el-spesifikt energibehov fra vindkraft',
    elChpEfficiency:
      'Årsgjennomsnittlig virkningsgrad for elektrisitetsproduksjon for kogenerering',
    elChpCoverage:
      'Energidekningsgrad av el-spesifikt energibehov fra kogenerering',
  },

  energyLabelConfig: {
    // air leakage
    airLeakageTitle: 'Luftlekkasje',
    airLeakageMeasured: 'Luftlekkasje målt',
    airLeakageMeasuredDate: 'Måledato',
    airLeakageGradeAHint:
      'Karakter A krever målt luftlekkasje med måledato. Uten dette blir karakteren maksimalt B.',
    // actions
    actionsTitle: 'Tiltak',
    includeMeasures: 'Inkluder tiltak under vurdering',
    includeActivatedActions: 'Inkluder aktiverte tiltak',
    loadingActions: 'Laster tiltak…',
    actionNameVentilation: 'Ventilasjonstiltak',
    actionNameHeating: 'Varme og kjøletiltak',
    actionNameLighting: 'Belysningstiltak',
    actionNameSolar: 'Solcelletiltak',
    actionNameControl: 'Styring & Regulering tiltak',
    actionsDescription:
      'Hvis ingen tiltak er inkludert, beskriv årsaken i stedet (f.eks. nybygg).',
    includedMeasuresInfo:
      'Listen med inkluderte tiltak inneholder en vurdering av kostnader og konsekvenser mht. fukt og inneklima knyttet til det enkelte energitiltaket. Listen kan brukes som grunnlag for å planlegge program for vedlikehold og oppgradering av bygningen.',
    description: 'Beskrivelse',
    // measured values
    measuredValuesTitle: 'Målte verdier',
    measuredValuesCheckbox: 'Målte verdier',
    measuredValuesDescription:
      'Energiforbruksmålinger etter kildetype for de siste 3 årene.',
    energySourcePlaceholder: 'Energikilde (kWh)',
    addMeasurement: 'Legg til måling',
    confirmDeleteMeasurement: 'Slette denne måleraden?',
    // energy source options
    deliveredElectricity: 'Levert elektrisitet (kWh)',
    exportedElectricity: 'Eksportert elektrisitet (kWh)',
    fossilOil: 'Fossil olje (kWh)',
    fossilGas: 'Fossil gass (kWh)',
    fossilSolidFuel: 'Fossilt fast brensel (kWh)',
    bioOil: 'Bioolje (kWh)',
    bioGas: 'Biogass (kWh)',
    bioSolidFuel: 'Bio fast brensel (kWh)',
    districtHeating: 'Fjernvarme (kWh)',
    districtCooling: 'Fjernkjøling (kWh)',
    other: 'Annen (kWh)',
    // matrikkel data accordion
    matrikkelDataTitle: 'Matrikkeldata',
    noUnitsFound: 'Ingen bruksenheter funnet',
    street: 'Adresse',
    addressCode: 'Adressekode',
    postcode: 'Postnummer',
    city: 'Poststed',
    municipality: 'Kommune',
    municipalityNumber: 'Kommunenummer',
    gnrBnr: 'Gnr/Bnr',
    leaseholdNumber: 'Festenummer',
    buildingNumber: 'Bygningsnummer',
    buildingType: 'Bygningstype',
    buildingStatus: 'Bygningsstatus',
    industryType: 'Næringsgruppe',
    unitNumber: 'Bruksenhetsnummer',
    unitId: 'Bruksenhets-ID',
    unitType: 'Enhetstype',
    sectionNumber: 'Seksjonsnummer',
    sectionType: 'Seksjonstype',
  },

  zoneSelection: {
    title: 'Soner å simulere',
    selectAll: 'Velg alle',
    deselectAll: 'Fjern alle',
    selected: '{count} av {total} valgt',
  },

  buildingTool: {
    showAll: 'Vis alle',
    hideAll: 'Skjul alle',
    updateZone: 'Oppdater sone',
    deleteZone: 'Slett sone',
    title: 'Bygningsverktøy',
    description:
      'Tegn en polygon på kartet for å markere bygningens grunnriss, juster parametere og opprett en sone med vegger.',
    numberOfFloors: 'Antall etasjer',
    floorHeight: 'Etasjehøyde (m)',
    startFloor: 'Startetasje',
    wallSegments: 'Veggflater',
    totalPerimeter: 'Total omkrets',
    creating: 'Oppretter...',
    createZoneAndWalls: 'Opprett sone og vegger',
    createSuccess: 'Sone og {count} vegg(er) opprettet',
    createError: 'Kunne ikke opprette sone og vegger',
    joinBearings: 'Slå sammen etter himmelretning',
    splitBearings: 'Vis alle segmenter',
    joinButton: 'Slå sammen',
    splitButton: 'Del opp',
    floorArea: 'Gulvareal (m²)',
    roofArea: 'Takareal (m²)',
    autoSelect: 'Auto',
    autoSelectHint: 'Klikk på en bygning for å velge grunnriss automatisk',
    noBuildingFound: 'Ingen bygning funnet',
    createAnother: 'Opprett ny sone',
    autoSelectTooltip: 'Velg automatisk',
    drawPolygonTooltip: 'Tegn polygon',
    drawStackedTooltip: 'Legg etasje over sone',
    drawStackedTooltipDisabled:
      'Legg etasje over sone (trenger en eksisterende sone først)',
    drawStackedHint: 'Klikk på en sone for å legge en kopi over',
    snapToggleOn: 'Snapping på',
    snapToggleOff: 'Snapping av',
    splitTooltip: 'Del en sone',
    splitTooltipDisabled: 'Del en sone (trenger en sone først)',
    splitTargetHint: 'Klikk på en sone for å dele',
    view3dTooltip: '3D-visning',
    splitPanelTitle: 'Del sone',
    splitPanelDescription:
      'Dra glidebryterene for å plassere kuttet. Sonen deles i to halvdeler.',
    splitPanelPickTargetHint:
      'Klikk på en sone på kartet for å velge hva som skal deles.',
    splitPanelSplittingZone: 'Deler: {name}',
    splitPanelCutPositionLabel: 'Kuttposisjon: {value}',
    splitPanelCutAngleLabel: 'Kuttvinkel: {value}°',
    splitPanelCutLengthLabel: 'Kuttlengde: {value}',
    splitPanelCutOffsetLabel: 'Kuttforskyvning: {value}',
    splitPanelConfirm: 'Bekreft deling',
    splitPanelCommitting: 'Deler…',
    errorUpdateZone: 'Kunne ikke oppdatere sone',
    errorCreateStackedZone: 'Kunne ikke legge til etasje over sone',
    errorSplitZone: 'Kunne ikke dele sone',
    errorDeleteZone: 'Kunne ikke slette sone',
  },

  underDevelopment: 'Denne siden er under utvikling.',

  // excel export labels for the input data sheet
  excelExport: {
    // column headers
    headerSection: 'Seksjon',
    headerName: 'Navn',
    headerParameter: 'Parameter',
    headerValue: 'Verdi',
    headerUnit: 'Enhet',
    // sheet tab name
    inputDataSheetName: 'Inndata',
    // boolean values
    boolYes: 'Ja',
    boolNo: 'Nei',
    // section names
    sectionThermalZones: 'Termiske soner',
    sectionExteriorWalls: 'Yttervegger',
    sectionHvacUnits: 'Ventilasjonsaggregat',
    sectionHeatingCoolingModules: 'Varme-/kjølemoduler',
    sectionCentralEnergyModules: 'Sentrale energimoduler',
    sectionHeatPumps: 'Varmepumper',
    sectionDistrictHeating: 'Fjernvarme',
    sectionCombustionBoilers: 'Forbrenningskjeler',
    sectionElectricBoilers: 'Elektriske kjeler',
    sectionSolarThermal: 'Solfangere',
    sectionOtherEnergySources: 'Andre energikilder',
    sectionSolarPv: 'Solceller',
    sectionDomesticHotWater: 'Varmtvann',
    sectionPipeConfigurations: 'Rørkonfigurasjoner',
    sectionProductionEquipment: 'Produksjonsutstyr',
    sectionExcessEnergy: 'Overskuddsenergi',
    // excel-specific short labels
    area: 'Areal',
    uValue: 'U-verdi',
    yearInstalled: 'Installasjonsår',
    energySource: 'Energikilde',
    systemEfficiency: 'Systemvirkningsgrad',
    usedForHeating: 'Brukes til oppvarming',
    usedForCooling: 'Brukes til kjøling',
    usedForDHW: 'Brukes til varmtvann',
    maxCapacity: 'Maks kapasitet',
    heatingCapacity: 'Varmekapasitet',
    cop: 'COP',
    heatingEffect: 'Varmeeffekt',
    coolingEffect: 'Kjøleeffekt',
    co2eEmissionFactor: 'CO\u2082e-utslippsfaktor',
    energyPrice: 'Energipris',
    power: 'Effekt',
    // entity prefixes
    prefixWall: 'Vegg',
    prefixWindow: 'Vindu',
    prefixDoor: 'Dør',
    prefixGate: 'Port',
    prefixPipe: 'Rør',
    prefixHeatingBattery: 'Varmebatteri',
    prefixCoolingBattery: 'Kjølebatteri',
    prefixDxSystem: 'DX-system',
    prefixEnergySource: 'Energikilde',
    prefixTank: 'Tank',
    prefixCopEntry: 'COP-oppføring',
    // thermal zones
    heatedFloorArea: 'Oppvarmet gulvareal (BRA)',
    numberOfFloors: 'Antall etasjer',
    floorHeight: 'Etasjehøyde',
    indoorTemperature: 'Starttemperatur',
    zoneClimate: 'Soneklima',
    airLeakageGrade: 'Luftlekkasje - Grad',
    airLeakageN50: 'Luftlekkasje - n50',
    setpointHeating: 'Settpunkt - Oppvarming',
    setpointCooling: 'Settpunkt - Kjøling',
    thermalBridgeType: 'Kuldebro - Type',
    thermalBridgePsiValue: 'Kuldebro - \u03C8-verdi',
    floorType: 'Gulv mot grunn - Type',
    floorArea: 'Gulv mot grunn - Areal',
    floorUValue: 'Gulv mot grunn - U-verdi',
    floorHeatLossCoeff: 'Gulv mot grunn - Varmetapskoeffisient',
    roofType: 'Yttertak - Type',
    roofArea: 'Yttertak - Areal',
    roofUValue: 'Yttertak - U-verdi',
    roofAngle: 'Yttertak - Vinkel',
    roofWindowArea: 'Yttertak - Vinduareal',
    roofWindowUValue: 'Yttertak - Vindu U-verdi',
    roofWindowGValue: 'Yttertak - Vindu g-verdi',
    basementArea: 'Kjeller - Gulvareal',
    basementWallPerimeter: 'Kjeller - Eksponert omkrets',
    basementFillHeight: 'Kjeller - Dybde under terreng',
    basementWallThickness: 'Kjeller - Veggtykkelse',
    basementWallUValue: 'Kjeller - Vegg U-verdi',
    basementFloorUValue: 'Kjeller - Gulv U-verdi',
    groundThermalConductivity: 'Grunn - Varmeledningsevne',
    groundHeatCapacity: 'Grunn - Varmekapasitet',
    groundPenetrationDepth: 'Grunn - Inntrengningsdybde',
    thermalMassCategory: 'Termisk masse - Kategori',
    thermalMassHeatCapacity: 'Termisk masse - Varmekapasitet',
    thermalMassNormalized: 'Termisk masse - Normalisert varmekapasitet',
    // windows
    gValue: 'g-verdi',
    shadingFactor: 'Skyggefaktor',
    externalBlinds: 'Utvendige persienner',
    externalBlindsGt: 'Utvendige persienner Gt',
    externalScreen: 'Utvendig screen',
    externalScreenGt: 'Utvendig screen Gt',
    internalShading: 'Innvendig solskjerming',
    internalShadingGt: 'Innvendig solskjerming Gt',
    // hvac
    heatRecoveryType: 'Varmegjenvinningstype',
    motorType: 'Motortype',
    flowType: 'Strømningstype',
    sfpSupply: 'SFP (tilluft)',
    sfpExtract: 'SFP (avtrekk)',
    sfpNonOperating: 'SFP utenfor drift',
    coverageArea: 'Dekningsareal',
    coverageVolume: 'Dekningsvolum',
    fanPowerSupply: 'Vifteeffekt (tilluft)',
    fanPowerExtract: 'Vifteeffekt (avtrekk)',
    heatRecoveryEfficiency: 'Varmegjenvinningsgrad',
    frostProtection: 'Frostbeskyttelse',
    frostProtectionTemperature: 'Frostbeskyttelsestemperatur',
    airVolumeOperatingSupply: 'Luftvolum drift (tilluft)',
    airVolumeCapacitySupply: 'Luftvolum kapasitet (tilluft)',
    airVolumeNonOperatingSupply: 'Luftvolum utenfor drift (tilluft)',
    airVolumeOperatingExtract: 'Luftvolum drift (avtrekk)',
    airVolumeCapacityExtract: 'Luftvolum kapasitet (avtrekk)',
    airVolumeNonOperatingExtract: 'Luftvolum utenfor drift (avtrekk)',
    supplyTemperature: 'Tilluftstemperatur',
    onlyNaturalPassiveVentilation: 'Kun naturlig/passiv ventilasjon',
    batteryEer: 'EER',
    // heating/cooling modules
    systemType: 'Systemtype',
    // central energy modules
    coolingOnly: 'Kun kjøling',
    ambientTemperature: 'Omgivelsestemperatur',
    tankPurpose: 'Formål',
    tankVolume: 'Volum',
    tankInsulationGrade: 'Isolasjonsgrad',
    tankHeatLossCoeff: 'Varmetapskoeffisient',
    tankSetpointTemp: 'Settpunkttemperatur',
    tankMaxTemp: 'Maks temperatur',
    tankMinTemp: 'Min temperatur',
    // heat pumps
    heatPumpType: 'Varmepumpetype',
    nominalLoad: 'Nominell last',
    minimumLoad: 'Minimum last',
    degradationCoefficient: 'Degraderingskoeffisient',
    liquidSource: 'Væskekilde',
    sourceTemperature: 'Kildetemperatur',
    sourceYearlyAvgTemp: 'Kilde årlig gj.snittstemperatur',
    sourceTempAmplitude: 'Kildetemperaturamplitude',
    copSourceTemp: 'Kildetemp',
    copMaxEffectLow: 'Maks effekt (lav temp)',
    copMaxEffectHigh: 'Maks effekt (høy temp)',
    copFullLoadLow: 'COP fulllast (lav temp)',
    copFullLoadHigh: 'COP fulllast (høy temp)',
    copNormalLoadLow: 'COP normallast (lav temp)',
    copNormalLoadHigh: 'COP normallast (høy temp)',
    copLowLoadLow: 'COP lavlast (lav temp)',
    copLowLoadHigh: 'COP lavlast (høy temp)',
    // combustion boilers
    boilerType: 'Kjeltype',
    efficiencyAtLowerLoad: 'Virkningsgrad ved lav last',
    effectAtFullLoad: 'Effekt ved full last',
    isCondensing: 'Kondenserende',
    seasonalMeanTemperature: 'Sesongmiddeltemperatur',
    fuelSource: 'Brenselkilde',
    fuelEnergyContent: 'Brensel energiinnhold',
    fuelCo2EmissionFactor: 'Brensel CO\u2082-utslippsfaktor',
    operatingStart: 'Driftsstart',
    operatingEnd: 'Driftsslutt',
    // electric boilers
    phi: 'Phi',
    insulationGrade: 'Isolasjonsgrad',
    // solar thermal
    tilt: 'Helning',
    collectorArea: 'Solfangerareal',
    pipeLength: 'Rørlengde',
    pipeUValue: 'Rør U-verdi',
    efficiencyAtNormalConditions: 'Virkningsgrad ved normalbetingelser',
    heatLossLinearCoefficient: 'Varmetap lineærkoeffisient',
    heatLossCoefficient: 'Varmetapskoeffisient',
    // other energy sources
    fuelType: 'Brenseltype',
    // solar pv
    panelArea: 'Panelareal',
    nominalEfficiency: 'Nominell virkningsgrad',
    panelAngle: 'Panelvinkel',
    panelAzimuth: 'Panel asimut',
    inverterEfficiency: 'Invertervirkningsgrad',
    degradationLoss: 'Degraderingstap',
    inverterLoss: 'Invertertap',
    transmissionProduct: 'Transmisjonsprodukt (0-1)',
    temperatureCoefficient: 'Temperaturkoeffisient (%/\u00B0C)',
    incidentAngleModifier: 'Innfallsvinkelmodifikator (0-1)',
    heatLossFactor: 'Varmetapsfaktor',
    pvMountingType: 'Monteringstype',
    windExposure: 'Vindeksponering',
    pvCellType: 'Celletype',
    // domestic hot water
    heaterType: 'Beredertype',
    useNormedData: 'Bruk normerte data',
    placementType: 'Plasseringstype',
    volume: 'Volum',
    setpointTemperature: 'Settpunkttemperatur',
    heatingElementPower: 'Varmeelementeffekt',
    specificHeatLoss: 'Spesifikt varmetap',
    maxPowerDemand: 'Maks effektbehov',
    usagePattern: 'Bruksmønster',
    heatContributionPercent: 'Varmebidragsprosent',
    distributionSystemType: 'Distribusjonssystemtype',
    pipeSpecificLength: 'Spesifikk rørlengde',
    tapCyclesPerDay: 'Tappesykluser per dag',
    pipesInHeatedRoom: 'Rør i oppvarmet rom',
    specificPumpPower: 'Spesifikk pumpeeffekt',
    pipeLinearUValue: 'Rør lineær U-verdi',
    avgTempOutsideHeatedRoom: 'Gj.snittstemperatur utenfor oppvarmet rom',
    greyWaterRecovery: 'Gråvannsgjenvinning',
    greyWaterEfficiency: 'Gråvannsvirkningsgrad',
    greyWaterShare: 'Gråvannsandel',
    greyWaterConnectionLossFactor: 'Gråvann tilkoblingstapsfaktor',
    greyWaterPatternLossFactor: 'Gråvann mønstertapsfaktor',
    // pipe configurations
    waterSystemQuality: 'Vannsystemkvalitet',
    pipeInsulationType: 'Rørisolasjonstype',
    spp: 'SPP',
    constantFlow: 'Konstant strømning',
    lengthOfPipe: 'Rørlengde',
    percentageInHeatedSpace: 'Andel i oppvarmet rom',
    avgTempOutsideHeatedSpace: 'Gj.snittstemperatur utenfor oppvarmet rom',
    temperatureReturn: 'Returtemperatur',
    temperatureSupply: 'Turtemperatur',
    // production equipment
    eligibleForHarvesting: 'Kvalifisert for energihøsting',
    // excess energy
    medium: 'Medium',
    temperature: 'Temperatur',
    amount: 'Mengde',
    ductShape: 'Kanalform',
    diameter: 'Diameter',
    width: 'Bredde',
    height: 'Høyde',
    airSpeed: 'Lufthastighet',
  },

  actions: {
    ventilation: {
      pageTitle: 'Ventilasjon',
      ventilationUnits: 'Ventilasjonsaggregater',
      noHvacUnits:
        'Ingen HVAC-aggregater funnet. Legg til HVAC-aggregater i HVAC-seksjonen først.',
      usingUnits:
        'Bruker {count} aktiverte ventilasjonsaggregat(er) fra bygningsbefaring.',
      enableUnitsHint:
        'Aktiver ventilasjonsaggregater nedenfor for å inkludere dem i tiltaket.',
    },
    lighting: {
      pageTitle: 'Belysning',
      thermalZones: 'Termiske soner',
      noZones:
        'Ingen termiske soner funnet. Legg til termiske soner i seksjonen for termiske soner først.',
      usingZones:
        'Bruker {count} aktiverte termiske sone(r) for belysningtiltaket.',
      enableZonesHint:
        'Aktiver termiske soner nedenfor for å inkludere dem i belysningtiltaket.',
      unit: 'W/m\u00B2',
      presenceControl: 'Tilstedeværelseskontroll (belysning)',
      presenceControlLabel: 'Tilstedeværelseskontroll:',
      presenceYes: 'Ja (faktor: {value})',
      presenceNo: 'Nei',
    },
    heating: {
      pageTitle: 'Oppvarming & kjøling',
      thermalZones: 'Termiske soner',
      usingZones:
        'Bruker {count} aktiverte termiske sone(r) for oppvarmingstiltaket.',
      enableZonesHint:
        'Aktiver termiske soner nedenfor for å inkludere dem i oppvarmingstiltaket.',
      addNewSystem: 'Legg til nytt system',
      addSystemDialogTitle: 'Legg til nytt system',
      template: 'Mal',
      systemName: 'Systemnavn',
      priorityHelp: '1 = høyeste prioritet',
      unnamed: 'Uten navn',
      chipNew: 'NY',
      chipRemoved: 'FJERNET',
      chipModified: 'ENDRET',
      remove: 'Fjern',
      delete: 'Slett',
      confirmDelete: 'Er du sikker på at du vil slette dette systemet?',
      undo: 'Angre',
      noExistingSystems:
        'Ingen eksisterende oppvarmings-/kjølesystemer i denne sonen.',
      enableZoneHint:
        'Aktiver denne sonen for å konfigurere oppvarmings-/kjølesystemer.',
      existingSystems: '{count} eksisterende system(er)',
      templateAirWaterHP: 'Luft/vann-varmepumpe',
      templateAirAirHP: 'Luft/luft-varmepumpe',
      templateAirToAirHP: 'Luft/luft-varmepumpe',
      templateGroundSourceHP: 'Bergvarmepumpe',
      templateElectricBoiler: 'Elektrisk kjel',
      templateDistrictHeating: 'Fjernvarme',
      templateDistrictCooling: 'Fjernkjøling',
    },
    solar: {
      pageTitle: 'Solceller',
      solarPvModules: 'Solcellemoduler',
      noModules:
        'Ingen solcellemoduler funnet. Legg til solcellemoduler i Solceller-seksjonen først.',
      usingModules:
        'Bruker {count} aktiverte solcellemodul(er) fra bygningsbefaring.',
      enableModulesHint:
        'Aktiver solcellemoduler nedenfor for å inkludere dem i tiltaket.',
      addNewModule: 'Legg til ny modul',
      chipNew: 'Ny',
      noExistingModules: 'Ingen eksisterende solcellemoduler.',
    },
    control: {
      pageTitle: 'Styring & Regulering',
      energyReductionPercent: 'Energireduksjon [%]',
      energyReductionHint:
        'Prosentvis reduksjon av total levert energi fra referansesimulering.',
    },
    overview: {
      overviewTitle: 'Tiltaksoversikt',
      combinedResults: 'Kombinerte simuleringsresultater',
      notSimulated: 'Ikke simulert ennå',
      noActiveActions:
        'Ingen aktive tiltak. Aktiver tiltak på de individuelle tiltakssidene.',
      activeActions: 'Aktive tiltak',
      runCombinedSimulation: 'Kjør bygningssimulering',
      noUnitsSelected: 'Ingen aggregater valgt',
      noZonesSelected: 'Ingen termiske soner valgt',
      noModulesSelected: 'Ingen moduler valgt',
      totalInvestment: 'Total investering',
      priorityUpdateFailed: 'Kunne ikke oppdatere prioritet',
    },
  },

  scenarioSync: {
    outOfSync:
      'Befaringen har endret seg siden dette tiltaket sist ble synkronisert.',
    legacyOutOfSync:
      'Befaringen har endret seg siden dette tiltaket ble laget. Tiltaket er eldre enn synkroniseringsstøtten, så lag et nytt tiltak for å få med de siste endringene.',
    reviewChanges: 'Se over endringer',
    notSet: 'Ikke satt',
    items: 'elementer',
    dialogTitle: 'Oppdater tiltak fra befaringen',
    dialogIntro:
      'Endringer fra befaringen tas inn automatisk, og dine egne endringer i tiltaket beholdes. Der begge har endret samme felt velger du hvilken verdi som skal gjelde.',
    conflictsHeading: 'konflikter trenger en avgjørelse',
    noConflicts: '0 konflikter',
    added: 'Ny',
    removed: 'Fjernet',
    removedInScenario: 'Slettet i dette tiltaket, slettingen beholdes',
    removeConflict: 'Slettet i befaringen, men endret i dette tiltaket',
    keepEntity: 'Behold',
    removeEntity: 'Slett',
    keepScenario: 'Behold verdien i tiltaket',
    takeParent: 'Bruk verdien fra befaringen',
    keptOverrides:
      'felt beholder dine endringer fra tiltaket (oppdateringen overskriver dem ikke)',
    noChanges: 'Ingen forskjeller å synkronisere.',
    markSynced: 'Merk som synkronisert',
    applySync: 'Oppdater tiltaket',
    syncSuccess: 'Tiltaket er oppdatert fra befaringen',
    syncError: 'Kunne ikke synkronisere tiltaket',
    resimulateHint:
      'Kjør simuleringen på nytt etterpå for å oppdatere resultatene.',
    collections: {
      inspection: 'Befaring',
      thermalZones: 'Soner',
      exteriorWalls: 'Yttervegger',
      windowAreas: 'Vinduer',
      doorAreas: 'Dører',
      gateAreas: 'Porter',
      operationalLoads: 'Internlaster',
      thermalZoneLinks: 'Sonekoblinger',
      hvacUnits: 'Ventilasjonsanlegg',
      heatingCoolingModules: 'Oppvarming og kjøling',
      centralEnergyModules: 'Sentral energi',
      combustionBoilers: 'Forbrenningskjeler',
      districtHeatings: 'Fjernvarme',
      electricBoilers: 'Elkjeler',
      otherSources: 'Andre energikilder',
      solarTermals: 'Solvarme',
      heatPumps: 'Varmepumper',
      productionEquipments: 'Produksjonsutstyr',
      solarPvModules: 'Solceller',
      excessEnergyModules: 'Overskuddsenergi',
      domesticHotWaters: 'Tappevann',
      actionModules: 'Tiltak',
      pipeLinks: 'Rørkoblinger',
      batteries: 'Batterier',
    },
  },

  scenario: {
    intro:
      'Lag én eller flere redigerbare kopier av denne befaringen. Endre det du ønsker i en kopi, kjør deretter simulering for å sammenligne med originalen.',
    introExisting:
      'Et tiltak for denne befaringen finnes allerede. Åpne det for å fortsette å redigere, eller start på nytt fra dagens tilstand av originalen.',
    bannerNotice:
      'Tiltak. Endringer her påvirker ikke den opprinnelige befaringen.',
    createScenario: 'Lag tiltak',
    addScenario: 'Legg til tiltak',
    scenarioName: 'Navn på tiltak',
    scenarioNamePlaceholder: 'f.eks. Nytt ventilasjonsanlegg',
    unnamedScenario: 'Tiltak uten navn',
    creating: 'Lager…',
    createNewScenario: 'Lag nytt tiltak',
    renameScenario: 'Rediger tiltakets navn og prioritet',
    deleteScenario: 'Slett tiltak',
    confirmDeleteScenario: 'Fjerne dette tiltaket?',
    working: 'Arbeider…',
    backToOriginal: 'Tilbake til original',
    confirmReplace:
      'Erstatte eksisterende tiltak med en ny kopi av originalen? Det nåværende tiltaket blir forkastet.',
    createFailed: 'Kunne ikke lage tiltak',
    replaceFailed: 'Kunne ikke erstatte tiltak',
    renameFailed: 'Kunne ikke gi tiltaket nytt navn',
    deleteFailed: 'Kunne ikke slette tiltak',
    existingCreated: 'Opprettet {date}',
    existingCreatedBy: 'Opprettet {date} av {name}',
    generalNotes: 'Generelle notater',
    generalNotesPlaceholder:
      'Forklar tiltaket så detaljert som mulig: hva som konkret ble endret og hvorfor.',
    notesRequired: 'Generelle notater er påkrevd',
    investmentCost: 'Investeringskostnad [NOK]',
    runToCompare: 'Kjør tiltakssimulering for å sammenligne',
    savingsUnavailable:
      'Besparelser kunne ikke beregnes ennå. Prisdata mangler eller er ufullstendig.',
    compareLeftLabel: 'Original',
    compareRightLabel: 'Tiltak',
    compareAgainst: 'Sammenlign med',
    noComparison: 'Ingen sammenligning',
    actionTypeLabel: 'Type tiltak',
    selectActionType: 'Velg type tiltak',
    actionTypes: {
      buildingShell: 'Bygningskropp',
    },
  },

  report: {
    dragDropHint: 'Endre rekkefølge på kapitler og felt i sidemenyen.',
    generateReport: 'Generer rapport',
    reportLanguage: 'Rapportspråk',
    addChapter: 'Legg til kapittel',
    exportToWord: 'Eksporter til Word',
    exportingToWord: 'Eksporterer til Word...',
    exportingProgress: 'Eksporterer til Word — {current} av {total}: {label}',
    sources: 'Kilder',
    noChapters: 'Ingen kapitler enda. Legg til et kapittel for å komme i gang.',
    editTitle: 'Rediger tittel',
    removeChapter: 'Fjern kapittel',
    noFields: 'Ingen tekstfelt enda. Legg til et felt for å begynne.',
    fieldTitlePlaceholder: 'Tittel på nytt felt...',
    addField: 'Legg til felt',
    confirmRemoveChapter: 'Fjerne kapittel "{title}"?',
    generateWithAI: 'Generer med AI',
    hideAuditLog: 'Skjul revisjonslogg',
    showAuditLog: 'Vis revisjonslogg',
    removeField: 'Fjern felt',
    promptLabel: 'Prompt (brukes til AI-generering)',
    promptPlaceholder: 'Skriv instruksjoner for AI-generering...',
    generateText: 'Generer tekst',
    textPlaceholder: 'Skriv innhold her, eller bruk AI-generering',
    confirmRemoveField: 'Fjerne felt "{title}"?',
    addChapterTitle: 'Legg til nytt kapittel',
    chapterTitleLabel: 'Kapitteltittel',
    chapterTitlePlaceholder: 'F.eks. Inneklima og komfort',
    fetchError: 'Kunne ikke hente rapport',
    saveError: 'Kunne ikke lagre rapport',
    generateError: 'Kunne ikke generere tekst',
    generatingStatus:
      'Rapporten genereres av AI. Dette kan ta flere minutter — siden oppdateres automatisk når den er klar.',
    generateSuccess: 'Rapporten ble generert',
    generateTimeout:
      'Rapportgenerering ble tidsavbrutt. Tjenesten kan fortsatt behandle — prøv å oppdatere siden senere.',
    noContent:
      'Ingen innhold ennå. Generer rapporten eller legg til tekst for å se en forhåndsvisning.',
    generationPromptLog: 'Generert med prompt:',
  },
};

export default BUILDING_INSPECTION;
